<template>
    <div id="vendor_wo_estimate_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="workOrderHeader" v-if="$route.params.id > 0">Update Vendor Estimate</span>
                    <span class="page-title" id="workOrderHeader" v-else>Add Vendor Estimate</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vendor-estimate-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="" id="VendorWoEstimateForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div v-if="$route.params.id > 0" class="col form-group">
                                        <label class="control-label require" for="reason_id">Estimate No:</label>
                                        <input type="text" disabled class="form-control" v-model="estimate_no" id="estimate_no" autocomplete="off" placeholder="Estimate No" name="estimate_no">
                                        <div class="field-error">{{estimate_no_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="notes">Estimate Amount:</label>
                                        <input type="text" class="form-control" v-model="estimate_amount" id="estimate_amount" autocomplete="off" placeholder="Estimate Amount" name="estimate_amount" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{ estimate_amount_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="vendor_id">Vendor:</label>
                                        <v-select v-model="vendor_id" name="vendor_id"
                                            label="text" :filterable="false" :options="vendorArr"
                                            @search="onSearchVendor" @input="onCustomerChange"
                                            placeholder="Select Vendor" class='custom-ci-auto-search close-remove'>
                                            <template slot="no-options">
                                                Search Vendor...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ customer_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_id">Unit:</label>
                                        <router-link class="pull-right color-blue link-text" v-bind:to="{name: 'AssetCreate', params:{newAsset: searchedAsset, redirectFrom: 'VendorEstimateCreate'}}">
                                            <i class="fp-add font-weight-bold" style="font-size:8px;"></i> Add Unit
                                        </router-link>
                                        <v-select v-model="vehicle_id" id="vehicle_select" name="vehicle_id"
                                            label="text" :filterable="false" :options="vehicleArr"
                                            @search="onSearchAsset" @input="onAssetChange"
                                            placeholder="Select Unit" class='custom-ci-auto-search close-remove'>
                                            <template slot="no-options">
                                                Search Unit...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ vehicle_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label">Open Date</label>
                                        <div class="input-group">
                                            <date-picker  placeholder="MM/DD/YYYY HH:MM:SS" id="open_date" name="open_date" v-model="open_date" :config="optionsDate" aria-describedby="basic-addon3" class='cal-icon'></date-picker>
                                            <label for="open_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Expiry Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="expiry_date" name="expiry_date" v-model="expiry_date" :config="optionsExpiryDate" aria-describedby="basic-addon3"
                                            class='cal-icon'></date-picker>
                                            <label for="expiry_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{expiry_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="user_id">User:</label>
                                        <v-select v-model="user_id" name="user_id" id="user_id"
                                            label="text" :filterable="false" :options="userArr"
                                            @search="onSearchUser"
                                            placeholder="Select User" class='custom-ci-auto-search contract-data close-remove'>
                                            <template slot="no-options">
                                                Search User...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ user_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="status">Maintenance Type:</label>
                                        <v-select v-model="maintenance_type_id" id="maintenance_type_id" name="maintenance_type_id" placeholder="Select Maintenance Type."
                                                label="text" class= 'close-remove'
                                                :options="maintenanceTypeArr" :disabled="disableMaintenanceTypeField">
                                        </v-select>
                                        <div class="field-error">{{ maintenance_type_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="status">Status:</label>
                                        <v-select v-model="wostatus" id="wostatus" name="wostatus" placeholder="Select Status."
                                                label="text" class= 'close-remove'
                                                :options="woStatusArr">
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="notes">Miles:</label>
                                        <input type="text" class="form-control" v-model="miles" id="miles" autocomplete="off" placeholder="Miles" name="miles" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{ miles_error_msg }}</div>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="control-label" for="notes">Notes:</label>
                                        <textarea class='form-control rounded-0' v-model="wonotes" ref="textarea" id="wonotes" rows="3"></textarea>
                                        <div class="field-error"></div>
                                    </div>

                                </div>
                                <div class="form-row">
                                    <div class="col form-group">
                                        <label class="control-label" for="vendorEstimateDropzone">Documents:</label>
                                        <vue-dropzone
                                                id="vendorEstimateDropzone"
                                                :options="dropzoneOptions"
                                                :destroyDropzone=false
                                                ref="dropzone"
                                                :headers="dropzoneOptions.headers"
                                                @vdropzone-complete="afterComplete"
                                                @vdropzone-success="storeDocument"
                                                @vdropzone-removed-file="removedSelectedFile"
                                                >
                                            </vue-dropzone>
                                    </div>
                                    <div class="col form-group">
                                        <div  v-if="dropZonePreviewFiles.length > 0">
                                            <div class="policy-attachment">
                                                <label class="control-label" for="vendorEstimateDocs">Attachments:</label>
                                                <template  v-for="(uFile,fKey) in dropZonePreviewFiles">
                                                    <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                                        <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                        <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                                        <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                                        <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                                            {{ uFile['display_name'] }}
                                                        </a>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                        <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="removeServerFile(uFile['file_name'],fKey);">
                                                            <i class="fp-close"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </section>
                        <hr class="light-hr"/>
                        <div class="work-order-create-section estimate-section mt-4 bg-white radius-5 p-3">
                            <h4>Add Items</h4>
                            <template v-if="taskArr.length == 0">
                                <h3>No Line Item Added</h3>
                            </template>
                            <template v-else>
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>VMRS</th>
                                                <th>Task</th>
                                                <th>Reason</th>
                                                <th>Part Fail</th>
                                                <th style="width:50px"></th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="taskArr != undefined && taskArr.length > 0">
                                            <template v-for="(task, index) in taskArr">
                                                <tr :key="index" :id="'showRow'+index" class="component-row">
                                                    <td style="width:24%">
                                                        <v-select v-model="task.component_category_id" name="component_category_id" placeholder="Select Component Category *"
                                                            label="text"
                                                            :options="vmrsArr" :id="'component_category_id'+index" @search="onSearchVMRS">
                                                        </v-select>
                                                    </td>
                                                    <td style="width:24%">
                                                        <v-select v-model="task.taskid" name="taskid" placeholder="Select Task *"
                                                            label="text"
                                                            :options="workOrderTaskArr" :id="'taskid'+index">
                                                        </v-select>
                                                    </td>
                                                    <td style="width:24%">
                                                        <v-select v-model="task.wi_reason_id" class="close-remove" name="wi_reason_id" placeholder="Select Reason."
                                                                label="text"
                                                                :options="reasonArr">
                                                        </v-select>
                                                    </td>
                                                    <td style="width:24%">
                                                        <v-select v-model="task.defect_id" class="close-remove" name="defect_id" placeholder="Select Standard Defect."
                                                                label="text"
                                                                :options="standardDefectsArr">
                                                        </v-select>
                                                    </td>
                                                    <td>
                                                        <i class="fp-close color-red close-icon" v-on:click="removeLine('task',index)"> </i>
                                                        <i v-bind:class="[(index === activeLineItemIdx) ? 'fp-up-arrow expand-arrow' : 'fp-down-arrow expand-arrow']" v-on:click=" activeLineItemIdx = (activeLineItemIdx === index)?'':index;"></i>
                                                    </td>
                                                </tr>
                                                <tr :id="'collapseRow'+index" v-bind:class="[(index === activeLineItemIdx) ? '' : 'accordion-btm-row']">
                                                <td colspan="5">
                                                    <div class="form-row">
                                                        <div class="col form-group">
                                                            <label class="control-label">Complaint:</label>
                                                            <textarea rows="3" v-model="task.woicomplaint" class="form-control" spellcheck="false" :id="'woicomplaint'+index"></textarea>
                                                        </div>
                                                        <div class="col form-group">
                                                            <label class="control-label">Cause:</label>
                                                            <textarea rows="3" v-model="task.woicause" class="form-control" spellcheck="false" :id="'woicause'+index"></textarea>
                                                        </div>
                                                        <div class="col form-group">
                                                            <label class="control-label">Correction:</label>
                                                            <textarea rows="3" v-model="task.woicorrection" class="form-control" spellcheck="false" :id="'woicorrection'+index"></textarea>
                                                        </div>
                                                        <div class="field-error" :id="'common_error_msg' + index"></div>
                                                    </div>
                                                    <div class="containerTab">
                                                        <div class="tabs">
                                                            <a id="getPastReservationList" v-on:click=" showTab = 'labor', laborActive = '', serviceTaskActive = 'active', partActive = '',activityActive = ''" :class="serviceTaskActive"> Labor </a>
                                                            <a id="getCurrentReservationList" v-on:click=" showTab = 'part', laborActive = 'active', serviceTaskActive = '', partActive = '',activityActive = ''" :class="laborActive"> Parts </a>
                                                            <a id="getPendingReservationList" v-on:click="showComments" :class="partActive"> Comments </a>
                                                            <a id="activityTab" v-on:click="showActivities(index)" :class="activityActive"> Activity</a>
                                                        </div>
                                                        <div class="tabcontent p-0 table-responsive-sm" v-if="showTab == 'labor'">
                                                            <a href="javascript:void(0)" class="color-blue pull-right mt-2 mb-2" v-on:click=" taskValidations('labor',index); clearLabor(); showActiveTaskLabor = (showActiveTaskLabor == 'addLabor'+index)?'':'addLabor'+index"><i class="fp-add font-weight-bold add-icon"></i> Add labor</a>
                                                            <table aria-describedby="table" class="table table-bordered table-sm font-1">
                                                                <thead>
                                                                    <tr class="table-primary">
                                                                        <th> Description </th>
                                                                        <th class="text-right">Labor Hours </th>
                                                                        <th class="text-right">Labor Amount </th>
                                                                        <th class="text-right"> Subtotal </th>
                                                                        <th class="text-center">Action </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <template v-if=" showActiveTaskLabor == 'addLabor'+index ">
                                                                        <tr :id="'addLabor'+index">
                                                                            <td>
                                                                                <textarea rows="1" class="form-control" v-model="labor_description" name="labor_description" spellcheck="false"></textarea>
                                                                                <div class="field-error">{{ serviceTaskLaborDesc_error_msg }}</div>
                                                                            </td>
                                                                            <td>
                                                                                <input placeholder="Hours" v-model="serviceTaskLaborHour" :id="'serviceTaskLaborHour' + index" v-on:keyup="calculateSubTotalForLabor()" name="serviceTaskLaborHour" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                                                <div class="field-error">{{ serviceTaskLaborHour_error_msg }}</div>
                                                                            </td>
                                                                            <td>
                                                                                <div class="input-group">
                                                                                    <div class="input-group-prepend">
                                                                                        <div class="input-group-text">$</div>
                                                                                    </div>
                                                                                    <input placeholder="Rate" v-model="serviceTaskLaborHourRate" id="serviceTaskLaborHourRate" v-on:keyup="calculateSubTotalForLabor()" name="serviceTaskLaborHourRate" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                                                </div>
                                                                                <div class="field-error">{{ serviceTaskLaborHourRate_error_msg }}</div>
                                                                            </td>
                                                                            <td class="text-right">
                                                                                ${{serviceTaskLaborSubTotal.toFixed(2)}}
                                                                                <!-- <div class="field-error">{{ serviceTaskLaborTotal_error_msg }}</div> -->
                                                                            </td>
                                                                            <td class="text-center">
                                                                                <button class="btn btn-primary" :disabled='isDisableStore' v-on:click="saveServiceTaskLabor(task.taskid, index)">Save </button>
                                                                                <button v-if="serviceTaskLaborIndex == 'create'" class="btn btn-secondary" v-on:click="clearLabor()"> Reset </button>
                                                                                <button v-if="serviceTaskLaborIndex != 'create'" class="btn btn-secondary" v-on:click="showActiveTaskLabor = ''; clearLabor()"> Cancel </button>
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                    <template v-else-if="task.hasLabor === true">
                                                                        <tr v-for="(labor, ind) in laborArr" :key="ind">
                                                                            <template v-if="(labor.service_task_id != null) && (labor.service_task_id.index == index)">
                                                                                <td> <p class="m-0" v-if="labor.labordescription != ''"> {{labor.labordescription}} </p> <p v-else> - </p></td>
                                                                                <td class="text-right"> {{labor.laborhours}} Hrs  </td>
                                                                                <td class="text-right">${{labor.laborhourrate}} </td>
                                                                                <td class="text-right"> ${{labor.laborsubtotal.toFixed(2)}}  </td>
                                                                                <td class="text-center">
                                                                                    <button style="line-height:12px" v-bind:class="[(ind === serviceTaskLaborIndex) ? 'btn-disable' : 'p-2']" v-on:click="editServiceTask('labor',ind, index)"> <i class="fp-edit-icon color-blue" style="font-size:15px"> </i></button>
                                                                                    <span class="border-right ml-3 mr-3"></span>
                                                                                    <button style="line-height:12px" v-bind:class="[(ind === serviceTaskLaborIndex) ? 'btn-disable' : 'p-2']" v-on:click="removeLine('labor',ind)"> <i class="fp-close color-red" style="font-size:12px"> </i></button>
                                                                                </td>
                                                                            </template>
                                                                        </tr>
                                                                    </template>
                                                                    <template v-else>
                                                                        <tr>
                                                                            <td colspan="5" class="text-center">
                                                                                No labor available
                                                                            </td>
                                                                        </tr>
                                                                    </template>

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div class="tabcontent p-0 table-responsive-sm" v-if="showTab == 'part'">
                                                            <a href="javascript:void(0)" class="color-blue pull-right mt-2 mb-2" v-on:click=" taskValidations('serviceTaskComp',index); clearServiceTaskComp(); showActiveTaskLabor = (showActiveTaskLabor == 'addComponent'+index)?'':'addComponent'+index" style="cursor:pointer;"><i class="fp-add font-weight-bold add-icon"></i> Add parts</a>
                                                            <table aria-describedby="table" class="table table-bordered table-sm font-1">
                                                                <thead>
                                                                    <tr class="table-primary">
                                                                        <th style="width:300px;"> Part name </th>
                                                                        <th> Description </th>
                                                                        <th> Parts Quantity </th>
                                                                        <th> Part Amount </th>
                                                                        <th> Subtotal </th>
                                                                        <th>  </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <template v-if=" showActiveTaskLabor == 'addComponent'+index">
                                                                        <tr :id="'addComponent'+index">
                                                                            <td>
                                                                                <v-select v-model="serviceTaskComp" name="serviceTaskComp"
                                                                                    label="text" :filterable="false" :options="componentArr"
                                                                                    @search="onSearchComponent"
                                                                                    placeholder="Search Part" class="custom-ci-auto-search">
                                                                                    <template slot="no-options">
                                                                                        Search Part...
                                                                                    </template>
                                                                                    <template slot="option" slot-scope="option">
                                                                                        <div class="d-center">
                                                                                            {{ option.text }}
                                                                                        </div>
                                                                                    </template>
                                                                                    <template slot="selected-option" slot-scope="option">
                                                                                        <div class="selected d-center">
                                                                                            {{ option.text }}
                                                                                        </div>
                                                                                    </template>
                                                                                </v-select>
                                                                                <div class="field-error">{{ serviceTaskComp_error_msg }}</div>
                                                                            </td>
                                                                            <td>
                                                                                <textarea rows="1" class="form-control" v-model="comp_description" name="comp_description" spellcheck="false"></textarea>
                                                                            </td>
                                                                            <td>
                                                                                <input type="text" placeholder="Quantity" v-model="serviceTaskCompQuantity" id="serviceTaskCompQuantity" v-on:keyup="calculateSubTotalForComp()" name="serviceTaskCompQuantity" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                                            </td>
                                                                            <td>
                                                                                <div class="input-group">
                                                                                    <div class="input-group-prepend">
                                                                                        <div class="input-group-text">$</div>
                                                                                    </div>
                                                                                    <input type="text" placeholder="Cost" v-model="serviceTaskCompCost" id="serviceTaskCompCost" v-on:keyup="calculateSubTotalForComp()" name="serviceTaskCompCost" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                                                </div>
                                                                            </td>
                                                                            <td class="text-right">
                                                                                ${{serviceTaskCompSubTotal.toFixed(2)}}
                                                                            </td>
                                                                            <td>
                                                                                <button class="btn btn-primary" :disabled='isDisableStore' v-on:click="saveServiceTaskComp(serviceTaskComp, task.taskid, index)"><i class="fp-save"></i> Save </button>
                                                                                <button v-if="serviceTaskCompIndex == 'create'" class="btn btn-secondary" v-on:click="clearServiceTaskComp()"> <i class="fp-refresh"></i> Reset </button>
                                                                                <button v-if="serviceTaskCompIndex != 'create'" class="btn btn-secondary" v-on:click="showActiveTaskLabor = ''; clearServiceTaskComp()"> <i class="fp-close"></i>Cancel </button>
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                    <template v-else-if="task.hasComp === true">
                                                                        <tr v-for="(comp, idx) in compArr" :key="'A'+idx">
                                                                            <template v-if="(comp.service_task_id != null) && (comp.service_task_id.index == index)">
                                                                                <td> {{comp.compid.text}} </td>
                                                                                <td class="text-right"> {{ comp.compquantity }} Qty  </td>
                                                                                <td class="text-right">$ {{ comp.compcost }} </td>
                                                                                <td class="text-right"> ${{comp.compsubtotal.toFixed(2)}}  </td>
                                                                                <td class="text-center">
                                                                                    <button style="line-height:12px" v-bind:class="[(idx === serviceTaskCompIndex) ? 'btn-disable' : 'p-2']" v-on:click="editServiceTask('component',idx, index)"> <i class="fp-edit-icon color-blue" style="font-size:15px"> </i></button>
                                                                                    <span class="border-right ml-3 mr-3"></span>
                                                                                    <button style="line-height:12px" v-bind:class="[(idx === serviceTaskCompIndex) ? 'btn-disable' : 'p-2']" v-on:click="removeLine('component',idx)"> <i class="fp-close color-red" style="font-size:12px"> </i></button>
                                                                                </td>
                                                                            </template>
                                                                        </tr>
                                                                    </template>
                                                                    <template v-else>
                                                                        <tr>
                                                                            <td colspan="6" class="text-center">
                                                                                No parts available
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div :id="'addComment'+index" class="tabcontent p-0" v-if="showTab == 'comment'">
                                                            <a href="javascript:void(0)" class="color-blue underline pull-right mt-2 mb-2 cursor-pointer" v-on:click=" comment_error_msg = ''; comment_type_error_msg = ''; taskValidations('comment',index); clearComment(); showActiveTaskLabor = (showActiveTaskLabor == 'addComment'+index)?'':'addComment'+index"> <i class="fp-add font-weight-bold add-icon"></i> Add Comment </a>
                                                            <template v-if=" showActiveTaskLabor == 'addComment'+index">
                                                                <div class="row clear">
                                                                    <div class="col-md-5 form-group">
                                                                        <label class="control-label require" for="comment_type_id">Select Type:</label>
                                                                        <v-select v-model="comment_type_id" name="comment_type_id" class="mt-4" placeholder="Select Comment Type"
                                                                            label="text"
                                                                            :options="commentTypeArr">
                                                                        </v-select>
                                                                        <div class="field-error">{{ comment_type_error_msg }}</div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-5 form-group">
                                                                        <label class="control-label require" for="exampleFormControlTextarea2">Description:</label>
                                                                        <textarea class="form-control" v-model="comment" ref="textarea" id="exampleFormControlTextarea2" rows="3" v-on:keyup="process($event)"></textarea>
                                                                        <div class="field-error">{{ comment_error_msg }}</div>
                                                                    </div>
                                                                </div>
                                                                <div class="btn-groups text-left">
                                                                    <button v-on:click="addComment(comment, comment_type_id, task.taskid, index)" class="btn btn-primary"> <i class="fp-save"> </i>{{submitBtn}}</button>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <ul class="comment-box clearfix">
                                                                    <template v-if="task.hasComment=== true">
                                                                        <li class="mb-4"><h4> All Comments </h4></li>
                                                                        <template v-for="(comment,ind) in commentArr">
                                                                            <template v-if="comment.service_task_id.index == index">
                                                                                <li :key="ind" class="work-order-list">
                                                                                    <span class="labor-icon"> {{ comment.wocBy.substring(0,2).toUpperCase() }} </span>
                                                                                    <div class="comment-details">
                                                                                        <div class="comment-dec"><span class="user">{{comment.wocBy}}</span>({{comment.wocType.text}}) <span>{{comment.wocAt}}</span> </div>
                                                                                        <p>{{comment.woc}}</p>
                                                                                    </div>
                                                                                    <div class="action-btns">
                                                                                        <button v-bind:class="[(ind === workOrderCommentIndex) ? 'btn-disable' : 'p-2']" v-on:click="editComment(comment.wocId, comment.wocType, comment.woCommentId, comment.woc, ind, index)"><i class="fp-edit-icon color-blue" style="font-size:15px"> </i></button>
                                                                                        <button v-bind:class="[(ind === workOrderCommentIndex) ? 'btn-disable' : 'p-2']" v-on:click.prevent="removeComment(comment.wocId)"><i class="fp-close color-red" style="font-size:12px"> </i> </button>
                                                                                    </div>
                                                                                </li>
                                                                            </template>
                                                                        </template>
                                                                    </template>
                                                                    <template v-else>
                                                                        <li class="text-center"> No comments available </li>
                                                                    </template>
                                                                </ul>
                                                            </template>
                                                        </div>
                                                        <div :id="'activity'+index" v-if=" showTab == 'activity'">
                                                            <ul class="comment-box clearfix">
                                                                <template v-if="showActivity == 'activity'">
                                                                    <li class="mb-4"><h4> Activity </h4></li>
                                                                    <template v-for="(activity,ind) in activityArr">
                                                                        <template v-if="activity.service_task_index == index">
                                                                            <li :key="ind" class="work-order-list">
                                                                                <span class="labor-icon"> {{ activity.activityBy.substring(0,2).toUpperCase() }} </span>
                                                                                <div class="comment-details">
                                                                                    <div class="comment-dec"><span class="user">{{ activity.activityBy }}</span>({{ activity.activity_type }}) <span>{{ activity.activityAt }}</span> </div>
                                                                                    <template v-for="(notes,notekey) in activity.notes">
                                                                                        <p :key="notekey" v-if="notes.key=='add'"><span class='updated-value'>{{ notes.val1 }}</span> {{ notes.val2 }}  <span class='updated-value'>{{ notes.val3 }}</span></p>
                                                                                        <p :key="notekey" v-if="notes.key=='is_added'"><span class='updated-value'>{{ notes.val1 }} </span><span class='updated-value'>{{ notes.val2 }}</span> {{ notes.val3 }}</p>
                                                                                        <p :key="notekey" v-if="notes.key=='update'"><span class='updated-value'>{{ notes.val1 }}</span> {{ notes.val2 }} <span class='updated-value'>{{ notes.val3 }}</span> {{ notes.val4 }} <span class='updated-value'>{{ notes.val5 }}</span></p>
                                                                                        <p :key="notekey" v-if="notes.key=='removed'"><span class='updated-value'>{{ notes.val1 }}</span><span class='updated-value'> {{ notes.val2 }}</span> {{ notes.val3 }}</p>
                                                                                        <p :key="notekey" v-if="notes.key=='delete'"><span class='updated-value'> {{ notes.val1 }}</span> {{ notes.val2 }} <span class='updated-value'>{{ notes.val3 }}</span></p>
                                        
                                                                                    </template>
                                                                                </div>
                                                                            </li>
                                                                        </template>
                                                                    </template>
                                                                </template>
                                                                <template v-else>
                                                                    <p class="text-center"> No activity available </p>
                                                                </template>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>

                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                            <hr class="light-hr">
                            <div class="btn-groups">
                                <button type="submit" @click="taskchange($event)" class="btn btn-primary">
                                    <i class="fp-add"> </i>  Add Line Item
                                </button>
                            </div>
                        </div>
                        <template v-if="displayLineItem == true">
                            <hr class="light-hr"/>
                            <div class="order-summary mt-4">
                                <div class="row">
                                    <div class="col-md-6 offset-md-6">
                                        <div class="bg-white radius-5 p-3">
                                            <label class="font-bold"> SUMMARY </label>
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <tr class="table-secondary">
                                                    <td>Labor:</td>
                                                    <td class="text-right">${{labor_total.toFixed(2)}}</td>
                                                </tr>
                                                <tr>
                                                    <td>Parts:</td>
                                                    <td class="text-right">${{parts_total.toFixed(2)}}</td>
                                                </tr>
                                                <tr class="table-secondary">
                                                    <td>Subtotal:</td>
                                                    <td class="text-right">${{sub_total.toFixed(2)}}</td>
                                                </tr>
                                                <tr>
                                                    <td>Total:</td>
                                                    <td class="order-total text-right">${{total.toFixed(2)}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <hr class="light-hr"/>
                        <div class="form-group">
                            <div class="alert alert-warning hide col-sm-6" id="alertError">
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <strong id="errorMsg" class="field-error">Please enter value</strong>
                            </div>
                        </div>
                        <div class="btn-groups mt-4">
                            <button type="submit" id="createWorkOrderBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateWoVendorEstimate(flag='final','workorder')">
                            <i class="fp-reload"> </i>  Update
                            </button>
                            <button type="submit" id="createWorkOrderBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateWoVendorEstimate(flag='final','workorder')">
                            <i class="fp-save"> </i>  Save
                            </button>
                            <button type="submit" id="createAndContinueWorkOrderBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateWoVendorEstimate(flag='Save and Continue','workorder')">
                            <i class="fp-save-continue"> </i>  Save and Continue
                            </button>
                            <button type="submit" id="cancelWorkOrderBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath">
                            <i class="fp-close"> </i>  Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import moment from 'moment';
//Vue DropZone
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
export default {
  name: "VendorEstimateCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Vendor Estimate | " +process.env.COPYRIGHT_NAME : "Create Vendor Estimate | " +process.env.COPYRIGHT_NAME
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({

    isDisableStore: false,
    serviceTaskLaborHourRate_error_msg: '',

    estimate_no: '',

    optionsExpiryDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },

    activeLineItemIdx:'',

    displayLineItem: false,
    woId: 0,

    commentArr:[],
    submitBtn:"Save",

    workOrderCommentId: 0,
    workOrderCId: 0,
    workOrderCommentIndex: 'create',

    comment:'',
    comment_type_id:null,
    comment_type_error_msg:'',
    comment_error_msg:'',
    commentTypeArr: [],
    woComment: [],

    maintenance_type_id: null,
    maintenanceTypeArr: [],
    maintenance_type_error_msg: '',
    miles_error_msg:'',
    estimate_amount_error_msg: '',

    estimate_amount: '',

    loggedInUser: '',

    laborTimeLogArr: [],

    woStatusArr: [
        {value: "open" , text:"Open"},
        {value: "sent" , text:"Sent"},
        {value: "responded" , text:"Responded"},
        {value: "approved" , text:"Approved"}
    ],
    wostatus: {
        value: "open" ,
        text: "Open"
    },

    vmrsArr: [],

    labor_description: '',
    comp_description: '',

    vendorArr: [],
    purchase_order_id: null,
    purchaseOrderArr: [],

    location_id: null,
    locationArr: [],
    isCustomerNotFound: false,
    isAssetNotFound: false,
    searchedAsset: '',
    searchedCustomer: '',

    extraLaborComp: false,
    woiDetail: [],
    woLaborDetail: [],
    woCompDetail: [],

    showActiveTaskLabor:'',

    serviceTaskComp_error_msg:'',
    serviceTaskCompIndex: 'create',
    serviceTaskCompId: 0,
    serviceTaskWoCompId: 0,
    serviceTaskComp:null,
    serviceTaskCompQuantity: 0,
    serviceTaskCompCost: 0,
    serviceTaskCompSubTotal: 0,

    serviceTaskCnt: 0,
    laborCnt: 0,
    componentCnt: 0,

    serviceTaskLaborIndex: 'create',
    serviceTaskLaborId: 0,
    // serviceTaskLabor:null,
    serviceTaskWoLaborId: 0,
    serviceTaskLaborHour: 0,
    serviceTaskLaborHourRate: 0,
    serviceTaskLaborSubTotal: 0,

    serviceTaskArr:[],

    showTab: 'labor',
    serviceTaskActive:"active",
    laborActive:"",
    partActive:"",

    taskArr: [],
    parts_total:0,
    labor_total:0,
    sub_total:0,
    tax:0,
    total_tax:0,
    discount:0,
    total_discount: 0,
    total:0,
    wonotes: "",

    task_error_msg:"",
    taskid_error_msg:"",
    laboramount_error_msg:"",
    partamount_error_msg:"",
    subtotal_error_msg:"",

    serviceTaskLaborDesc_error_msg:"",
    serviceTaskLaborTotal_error_msg:"",

    //labor tab related
    laborArr: [],
    labor_id:null,

    labor_error_msg:"",
    laborid_error_msg:"",
    laborhours_error_msg:"",
    hourrate_error_msg:"",

    //part tab related
    comp_id: null,
    compArr: [],
    permissions: [],
    cantAccessPage: "",

    vehicle_id:null,
    customer_id:null,
    vendor_id:null,
    open_date:"",

    miles:null,

    optionsDate: {
        format: 'MM/DD/YYYY hh:mm:ss a',
        useCurrent: false,
        showClose: true,
    },
    requested_completion:"",
    agreed_date:"",
    expiry_date:"",

    user_id:null,

    priority:null,

    vehicleArr: [],
    customerArr:[],
    shopArr:[],
    userArr:[],
    reasonArr:null,
    priorityArr:[],
    costCodeArr:[],
    loading:false,
    estimate_no_error_msg: "",
    vehicle_error_msg: "",
    customer_error_msg: "",
    location_error_msg: "",
    user_error_msg: "",
    reason_error_msg:"",
    expiry_date_error_msg:"",
    itemArr: [],
    componentArr:[],
    component:"",
    component_error_msg: "",
    task_id: "",
    workOrderTaskArr: [],
    component_id:null,
    hours: "",
    hours_error_msg: "",
    wi_user_id: "",
    wi_user_id_error_msg: "",

    standardDefectsArr: [],
    defect_error_msg: "",
    wi_reason_id: "",
    wi_reason_error_msg: "",
    wi_cost_code: "",
    wi_cost_code_error_msg: "",

    blockRemoval: true,
    role:'',

    estimateNoInfo:'',
    estimateAmountInfo: '',
    assetInfo:'',
    customerInfo:'',
    VendorInfo:'',
    openDateInfo:'',
    requestCompInfo:'',
    agreedDateInfo:'',
    userInfo:'',
    woStatusInfo:'',
    milesInfo:'',
    locationInfo:'',
    priorityInfo:'',
    woNotesInfo:'',
    maintenanceTypeInfo:'',
    expiryDateInfo:'',
    laborIndex:0,
    serviceTaskLaborHour_error_msg: "",
    // isEditLabor:false,
    activityActive:'',
    activityArr:[],
    showActivity:'',

    files:[],
    dropzoneOptions: {
        url: process.env.ROOT_API +"/vendor-estimate/store-docs",
        method: 'POST',
        maxFilesize: 3.99, //MB
        maxFiles: 3,
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true,
        acceptedFiles: ".jpg, .jpeg, .png, .doc, .pdf, .docx",
        headers: {
            'Accept': 'application/json',
            "Authorization": "Bearer "+localStorage.getItem("tkn"),
            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
            "Cache-Control": "no-cache"
        },
        dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
        destroyDropzone:false,
    },
    dropZonePreviewFiles:[],
    disableMaintenanceTypeField:false,
    fromWorkorderId : 0,
    fromWOFlag:false,
    open_date_error_msg:""
  }),
  watch:{

        serviceTaskLaborHour:function(){

            var self = this;
            self.calculateSubTotalForLabor();

        },
        sub_total:function(){

            var self = this;
            self.total=(self.sub_total);

        },

        tax:function(){
            var self = this;
            self.calculateTaxDiscountAmount();
        },

        discount:function(){
            var self = this;
            self.calculateTaxDiscountAmount();
        },

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_vendor_estimate') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },

        vehicle_id: function(newValue, oldValue) {
            var self = this;
            if(newValue != null && self.displayLineItem == false){
                self.getAssetReservationDetails(newValue.value);
            }
        },

        itemArr() {
            var self = this;
            self.blockRemoval = self.itemArr.length <= 1
        },

        taskArr: {
            handler: function(newValue) {
                var self = this;
                self.serviceTaskCnt = newValue.length;
            },
            deep: true
        },

        commentArr: {
            handler: function(newValue) {
                var self = this;

                for ( var i = 0; i < self.serviceTaskArr.length; i++ ) {

                    var comment = false;
                    var serviceTaskIdx = self.serviceTaskArr[i].index;

                    for ( var j = 0; j < newValue.length; j++ ) {

                        if(newValue[j].service_task_id != null){

                            var taskIdx = newValue[j].service_task_id.index;

                            if(taskIdx == serviceTaskIdx){

                                comment = true;

                            }

                        }
                    }

                    self.taskArr[serviceTaskIdx].hasComment = comment;

                }
            },
            deep: true
        },

        laborArr: {
            handler: function(newValue) {
                var self = this;
                self.laborCnt = newValue.length;

                for ( var k = 0; k < self.serviceTaskArr.length; k++ ) {

                    var lamount = 0
                    var hasTechnician = false;
                    var serviceTaskIdx = self.serviceTaskArr[k].index;
                    console.log('var serviceTaskIdx = '+serviceTaskIdx)

                    for ( var i = 0; i < newValue.length; i++ ) {

                        if(newValue[i].service_task_id != null){

                            var taskIdx = newValue[i].service_task_id.index;

                            if(taskIdx == serviceTaskIdx){

                                lamount +=  parseInt(newValue[i].laborsubtotal);
                                hasTechnician = true

                            }

                        }
                    }

                    if(hasTechnician == true){

                        if (!$('#laboramount'+serviceTaskIdx).hasClass('disable-field')) {

                            $("#laboramount"+serviceTaskIdx).addClass("disable-field");
                        }

                        self.taskArr[serviceTaskIdx].hasLabor = true;
                        console.log('testing here - serviceTaskIdx '+serviceTaskIdx)
                        // console.log('testing here - lamount '+lamount)
                        // self.taskArr[serviceTaskIdx].laboramount = lamount;

                    }else{

                        if ($('#laboramount'+serviceTaskIdx).hasClass('disable-field')) {

                            $("#laboramount"+serviceTaskIdx).removeClass("disable-field");

                        }

                    }

                    console.log('testing here - lamount '+lamount)
                    if(newValue.length > 0){
                        self.taskArr[serviceTaskIdx].laboramount = lamount;
                    }
                    self.calculateTotalAmount();
                }
            },
            deep: true
        },
        compArr: {
            handler: function(newValue) {
                var self = this;
                self.componentCnt = self.compArr.length;

                for ( var i = 0; i < self.serviceTaskArr.length; i++ ) {

                    var camount = 0
                    var hasPart = false;
                    var serviceTaskIdx = self.serviceTaskArr[i].index;

                    for ( var j = 0; j < newValue.length; j++ ) {

                        if(newValue[j].service_task_id != null){

                            var taskIdx = newValue[j].service_task_id.index;

                            if(taskIdx == serviceTaskIdx){

                                camount +=  parseInt(newValue[j].compsubtotal);
                                hasPart = true;

                            }

                        }
                    }

                    if(hasPart == true){

                        if (!$('#partamount'+serviceTaskIdx).hasClass('disable-field')) {

                            $("#partamount"+serviceTaskIdx).addClass("disable-field");

                        }

                        self.taskArr[serviceTaskIdx].hasComp = true;
                        // self.taskArr[serviceTaskIdx].partamount = camount;


                    }else{

                        if ($('#partamount'+serviceTaskIdx).hasClass('disable-field')) {

                            $("#partamount"+serviceTaskIdx).removeClass("disable-field");

                        }

                    }

                    if(newValue.length > 0){
                        self.taskArr[serviceTaskIdx].partamount = camount;
                    }

                    self.calculateTotalAmount();
                }
            },
            deep: true
        }
   },
  created: function() {

  },
  mounted: function() {

        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        self.getPermissions();

        self.loadFieldData(['work_order_comment','location','reason','priority','costcode','standarddefects','workordertask','maintenance_type']);

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if(userObj != null){
            // var userJson = JSON.parse(userObj);
            // if (userObj.roles.length > 0) {
            //     self.role = userObj.roles[0].name;

            // }

            var dateTimeFormat = userObj["date_format"] + " " + userObj["time_format"];
            if(dateTimeFormat != null){
                console.log(dateTimeFormat);
                //set date time format in optionsDate format of date picker
            }

            // set LoggedIn user's location as default location....
            if(userObj["location_id"] != null && userObj["location_id"]  != ''){
                self.location_id = {value: userObj["location_id"], text: self.titleCase(userObj["locationName"]) };
            }

            // set LoggedIn user as default user....
            if(userObj["last_name"] != null && userObj["last_name"] != ''){
                self.user_id = self.loggedInUser = {value: userObj["id"], text: self.titleCase(userObj["first_name"]) + " " + self.titleCase(userObj["last_name"])};
            }else{
                self.user_id = self.loggedInUser = {value: userObj["id"], text: self.titleCase(userObj["first_name"])};
            }
        }

        if(!segments[3]){

            self.open_date = moment().format('MM/DD/YYYY hh:mm:ss a');

            //if available set asset value => when user is redirected from Add Customer...
            if ( localStorage.getItem("newAsset") != null ) {
                self.vehicle_id = JSON.parse(localStorage.getItem("newAsset"));
            }

            //if available set customer value => when user is redirected from Add Asset...
            if ( localStorage.getItem("newCustomer") != null ) {
                self.customer_id = JSON.parse(localStorage.getItem("newCustomer"));
            }

            //Get Vendor Estimate Number
            //self.getVendorEstimateNo();
        }

        if(self.$route.params.redirectTo == 'Add Vendor Estimate Unit'){

            var vehicleData = self.titleCase(self.$route.params.assetUnitNo);
            if(self.$route.params.assetType != null && self.$route.params.assetType != ''){
                if(self.$route.params.assetType.vtCode != null && self.$route.params.assetType.vtCode != ''){
                    vehicleData += " | " + self.titleCase(self.$route.params.assetType.vtCode);
                }
            }
            if(self.$route.params.assetName != null && self.$route.params.assetName != ''){
                vehicleData += " | " + self.titleCase(self.$route.params.assetName);
            }
            if(self.$route.params.assetLocation != null && self.$route.params.assetLocation != ''){
                if(self.$route.params.assetLocation.location_name != null && self.$route.params.assetLocation.location_name != ''){
                    vehicleData += " | " + self.titleCase(self.$route.params.assetLocation.location_name);
                }
            }
            self.vehicle_id = {value: self.$route.params.assetId, text: vehicleData};

            //set newAsset value to localStorage...when user is redirected from Add Asset..
            localStorage.setItem("newAsset",JSON.stringify({value: self.$route.params.assetId,text: vehicleData}));

        }
        // else if (self.$route.params.redirectTo == 'Add Vendor Estimate Customer'){

        //     self.customer_id = {value: self.$route.params.customerId , text : self.formatString(self.$route.params.customerName) + " (" + self.$route.params.customerCode + ")"};

        //     localStorage.setItem("newCustomer",JSON.stringify({value: self.$route.params.customerId,text: self.formatString(self.$route.params.customerName) + " (" + self.$route.params.customerCode + ")"}));

        // }

        // if(self.$route.params.customerId != null && self.$route.params.customerId != ''){

        //     self.customer_id = {value: self.$route.params.customerId , text : self.formatString(self.$route.params.customerName) + " (" + self.$route.params.customerCode + ")"};

        // }
        var webloc = window.location.href;

         var decodeStr = "";

        if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {

            decodeStr = atob(this.$route.query.data)

        }

        var url = new URL(webloc+"?"+decodeStr);
        var woId = url.searchParams.get("woId");
        var woiId = url.searchParams.get("woItemId");
        var from = url.searchParams.get("redirectFrom");


        setTimeout(function () {

            if (segments[3]) {
                if ( self.$route.query.flag == 'main' ) {
                    self.displayLineItem = false;
                } else {
                    self.displayLineItem = true;
                }

                self.loadWoVendorEstimate();

                //one can not change maintenance type while updating...
                // $("#maintenance_type_id").addClass("disable-field");
                self.disableMaintenanceTypeField = true;
            }
        }, 1500);

        self.taskchange('mounted');

        setTimeout(function () {
            if(from == 'WorkOrderView'){
                self.fromWOFlag = true;
                self.fromWorkorderId = woId;
                self.loadWorkOrder(woId)
                self.getWorkOrderDataForEstimate(woId,woiId);
            }
        },1000);

  },
  methods: {
      loadWorkOrder(wo_id) {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;


            $.ajax({
                url: process.env.ROOT_API + "/workorder/" + wo_id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
// alert(data.content.miles);
                        // self.work_order_no = data.content.work_order_no;

                        if (data.content.vehicle_id != null) {
                            var vehicleData = self.titleCase(data.content.vUnitNo);
                            if (data.content.vtCode != null) {
                                vehicleData += " | " + self.titleCase(data.content.vtCode);
                            }
                            if (data.content.vName != null) {
                                vehicleData += " | " + self.titleCase(data.content.vName);
                            }
                            self.vehicle_id = {
                                value: data.content.vehicle_id,
                                text: vehicleData
                            };
                            self.assetInfo = vehicleData;
                        } else {
                            self.vehicle_id = null;
                        }
                        self.miles = data.content.miles;
                        self.open_date = data.content.open_date;

                        if (data.content.uLastName != null) {
                            self.user_id = {
                                value: data.content.user_id,
                                text: self.titleCase(data.content.uFirstName) + " " + self.titleCase(data.content.uLastName)
                            };
                            self.userInfo = self.titleCase(data.content.uFirstName) + " " + self.titleCase(data.content.uLastName);
                        } else {
                            self.user_id = {
                                value: data.content.user_id,
                                text: self.titleCase(data.content.uFirstName)
                            };
                            self.userInfo = self.titleCase(data.content.uFirstName);
                        }
                        self.maintenanceTypeInfo = self.titleCase(data.content.maintenanceTypeName);
                        // self.wostatus = {
                        //     value: data.content.status,
                        //     text: self.formatString(data.content.status)
                        // };
                        if (data.content.lState != null) {
                            self.locationInfo = data.content.lCode + " | " + data.content.lName + ", " + data.content.lState;
                        } else {
                            self.locationInfo = data.content.lName + " | " + data.content.lCode;
                        }

                        self.wonotes = data.content.description;

                        if (data.content.location_id) {
                            self.location_id = {
                                value: data.content.location_id,
                                text: self.titleCase(data.content.lName) + ' | ' + data.content.lCode
                            };
                        }

                        if (data.content.maintenanceTypeId) {
                            self.maintenance_type_id = {
                                value: data.content.maintenanceTypeId,
                                text: self.titleCase(data.content.maintenanceTypeName)
                            };
                        }


                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true,'vendor-estimate-wo-detail');
                }
            });
        },

      //load files in drop zone
        loadFilesPreview:function() {
            var self = this;
            if ( self.dropZonePreviewFiles.length > 0 ) {

                for ( var i = 0;i<self.dropZonePreviewFiles.length;i++ ) {

                    var file = { size: self.dropZonePreviewFiles[i].size, name: self.dropZonePreviewFiles[i].file_name, type: self.dropZonePreviewFiles[i].file_type};
                    var url = self.dropZonePreviewFiles[i].url;
                    //get file path from url
//                    self.files.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
                    //self.$refs.dropzone.manuallyAddFile(file, url);
                }
            }
        },

        removedSelectedFile(file, xhr, error) {
            var self = this;

            var woveId = "";
            var fileName = JSON.parse(file.xhr.response).content;

            var fileArr = fileName.split("/");

            self.removeFileFromServer(fileArr[1],woveId,"temp");

            for(var i = 0;i<self.files.length;i++){
                if ( self.files[i].includes(fileName)) {
                    self.files.splice(i,1);
                }
            }

            console.log(self.files);

        },

        getFilePathFromUrl (value) {

            var path = "";
            var src = value.split('/');
            var file_name = src[src.length - 1];
            var orgPath = src[src.length - 2];
            path = orgPath + "/" + file_name;
            return path;

        },

        removeServerFile(fileName,key) {

            var self = this;
            var woveId = "";
            var path = window.location.pathname;
            var segments = path.split("/");
            if ( segments[3] != undefined ) {
                woveId = segments[3];
            }

            if (confirm('Are you sure that you want to remove file? ')) {

                self.removeFileFromServer(fileName,woveId,"server");
                self.dropZonePreviewFiles.splice(key,1);

                //remove file from files array
                for ( var i = 0;i<self.files.length;i++ ) {
                    if ( self.files[i].includes(fileName)) {
                        self.files.splice(i,1);
                    }
                }
            }

        },

        afterComplete(file,response){
            var self = this;
        },

        storeDocument(file,response){
            var self = this;
            var uploadResponse = response.content;
            //push doc path in files array
            self.files.push(uploadResponse);

        },

        showComments: function() {

            var self = this;
            self.showTab = 'comment';
            self.laborActive = '';
            self.serviceTaskActive = '';
            self.partActive = 'active';
            self.activityActive = '';
            setTimeout(function () {
                $('.comment-list-btm').jScrollPane();
            },1000);
        },

        showActivities: function(index) {
            var self = this;
            self.showTab = 'activity';
            self.activityActive = 'active';
            self.laborActive = '';
            self.serviceTaskActive ='';
            self.partActive = '';
            setTimeout(function () {
                $('.activity-list-btm').jScrollPane();
            },200);

            var hasActivity = false;

            for(var i=0;i<self.activityArr.length;i++){

                if(self.activityArr[i].service_task_index == index){
                    hasActivity = true;
                }
            }

            if(hasActivity){
                self.showActivity = 'activity';
            }else{
                self.showActivity = '';
            }
        },

        //add comment with enter key press
        process: function (e ) {
            var code = (e.keyCode ? e.keyCode : e.which);
            if (code === 13) { //Enter keycode
                this.submitComment();
            }
        },

        addComment(comment, commentType, task, taskIndex){

            var self = this;
            var error = false;
            self.comment_error_msg = '';
            self.comment_type_error_msg = '';

            var index = self.workOrderCommentIndex;

            if(comment == ''){

                self.comment_error_msg = 'Comment is required';
                error = true;

            }

            if(commentType == null){

                self.comment_type_error_msg = 'Comment Type is required';
                error = true;

            }

            if(!error){

                if(index == 'create'){

                    self.commentArr.push({
                        //if one is adding new comment wocId => 0 or wocId => comment id..
                        wocId: 0,
                        service_task_id: {value: task.value, text:task.text, index: taskIndex},
                        wocType: commentType,
                        woc: comment,
                        wocBy: self.loggedInUser.text,
                        wocAt: moment(self.getCurrentDateTime()).format("MM/DD/YYYY h:mm")
                    });

                }else{

                    self.commentArr[index].wocId = (self.workOrderCommentId != 0)?self.workOrderCommentId:0;
                    self.commentArr[index].service_task_id = {value: task.value, text:task.text, index: taskIndex};
                    self.commentArr[index].wocType = commentType;
                    self.commentArr[index].woc = comment;
                    self.commentArr[index].wocBy = self.loggedInUser.text;
                    self.commentArr[index].wocAt = moment(self.getCurrentDateTime()).format("MM/DD/YYYY h:mm");

                }

                self.comment = '';
                self.comment_type_id = null;
                self.workOrderCommentId = 0;
                self.workOrderCId = 0;
                self.workOrderCommentIndex = 'create';

                self.showActiveTaskLabor = '';
                var itemFlag='comment';
                setTimeout(function () {

                    self.CreateWoVendorEstimate('',itemFlag);

                }, 500);

            }else{
            self.errorValidationFocus();
            }

        },

        editComment:function(c_id, c_type, woc_Id, comment, c_index, serviceTaskIndex){

            var self = this;
            self.showActiveTaskLabor = 'addComment'+serviceTaskIndex;
            self.comment_error_msg = "";
            self.comment_type_error_msg = "";
            self.workOrderCommentId = c_id;
            self.workOrderCId = woc_Id;
            self.workOrderCommentIndex = c_index;
            self.comment_type_id = {value: c_type.value, text: c_type.text};
            self.comment = comment;
            // self.$refs.textarea.focus();
        },

        removeComment:function(c_id){
            var self = this;
            self.comment_error_msg = "";
            self.comment_type_error_msg = "";

            if (confirm('Are you sure that you want to remove this comment? ')) {

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/vendor-estimate/remove-wo-vendor-estimate-comment",
                    type: "POST",
                    data: {'id':c_id},
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false;
                        if (data.code == '200') {
                            self.loadWoVendorEstimate();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, true,'remove-vendor-estimate-comment');
                    }
                });
            }

        },

        getAssetReservationDetails(v_id){
            var self = this;

            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/reservation/getCurrentReservation",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType:"json",
                data:{
                    vehicle_id: v_id,
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == 'success') {
                        // self.showDetailInfo = 'show';
                        if(data.content.custId != undefined){
                            self.customer_id = {value: data.content.custId , text : self.formatString(data.content.custName) + " (" + data.content.custCode + ")"};
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true,'vendor-estimate-get-current-reservation');
                }
            });


        },

        addSetOfTask(){
            return;
            // var self = this;
            // console.log('evt maintenance value => '+self.maintenance_type_id.value)
            // console.log('evt maintenance text => '+self.maintenance_type_id.text)

            // self.loading = true;

            // $.ajax({
            //     url: process.env.ROOT_API + "/workorder/get-workorder-template",
            //     type: "GET",
            //     headers: this.ajxHeaders,
            //     crossDomain: true,
            //     dataType:"json",
            //     data:{
            //         maintenance_id: self.maintenance_type_id.value
            //     },
            //     success: function (data) {
            //         self.loading = false;
            //         //PR
            //         self.taskArr = [];
            //         self.laborArr = [];
            //         self.compArr = [];

            //         if (data.code == 200) {

            //             console.log("JSON Response = >" + JSON.stringify(data.content))

            //             for ( var i=0; i<data.content.length; i++ ) {

            //                 self.taskArr.push({

            //                     woiId: 0,
            //                     taskid: (data.content[i].task_id != undefined && data.content[i].task_id != null && data.content[i].task_id != '')?{value: data.content[i].task_id, text: self.titleCase(data.content[i].task_name + " (" + data.content[i].task_code +")")}:null,
            //                     laboramount: 0,
            //                     partamount: 0,
            //                     component_category_id: (data.content[i].component_category_id != undefined && data.content[i].component_category_id != null && data.content[i].component_category_id != '')?{value: data.content[i].component_category_id, text: self.titleCase(data.content[i].component_category_name + " (" + data.content[i].component_category_code +")")}:null,
            //                     wi_reason_id: null,
            //                     defect_id: null,
            //                     woicomplaint: '',
            //                     woicause: '',
            //                     woicorrection: '',
            //                     subtotal: 0,
            //                     hasLabor: false,
            //                     hasComp: false,
            //                     hasComment: false,
            //                     workOrderItemId:0

            //                 });
            //             }

            //             self.activeLineItemIdx = 0;

            //         }
            //     },
            //     error: function (jqXHR, exception) {
            //         self.loading = false;
            //         self.Registerbtn = "Register";
            //         self.generateStatusCodeMessage(jqXHR, true,'vendor-estimate-get-wo-template');
            //     }
            // });
        },

    //to da - temp
    calculateDays(startDate,endDate){
        console.log('startDate ==>'+startDate);
        console.log('endDate ==>'+endDate);

        var start = new Date(startDate);
        var end = new Date(endDate);
        var diff = end.getTime() - start.getTime();
        var time_difference = new Object();

        time_difference.hours = Math.floor(diff/1000/60/60);
        console.log("time_difference.hours :: " + time_difference.hours);
        diff -= time_difference.hours*1000*60*60;
        if(time_difference.hours < 10) time_difference.hours = "0" + time_difference.hours;

        time_difference.minutes = Math.floor(diff/1000/60);
        console.log("time_difference.minutes :: " + time_difference.minutes);
        diff -= time_difference.minutes*1000*60;
        if(time_difference.minutes < 10) time_difference.minutes = "0" + time_difference.minutes;

        // return time_difference;
        return time_difference.hours+':'+time_difference.minutes;

    },

    onCustomerChange(){
        var self = this;
        console.log('newCustomer removed from localStorage')
        localStorage.removeItem('newCustomer');
    },

    onAssetChange(){
        var self = this;
        console.log('newAsset removed from localStorage')
        localStorage.removeItem('newAsset');
    },

    saveServiceTaskLabor(task, taskIndex){
        console.log('save labor called with - '+ JSON.stringify(task));
        var self = this;
        var error = false;
        //add labor to laborArr if added new..

        var index = self.serviceTaskLaborIndex;

        self.serviceTaskLaborDesc_error_msg = '';
        self.serviceTaskLaborHour_error_msg ='';

        if(self.labor_description == null || self.labor_description == ""){
            self.serviceTaskLaborDesc_error_msg = 'Description Required';
            error = true;
        }
        if(self.serviceTaskLaborHour == null || self.serviceTaskLaborHour == 0 || self.serviceTaskLaborHour < 0){
            self.serviceTaskLaborHour_error_msg = 'Labor hours should be greater than 0';
            error = true;
        }
        if(self.canViewWoSummary){
            if(self.serviceTaskLaborSubTotal == 0 || self.serviceTaskLaborSubTotal < 0 ){
                self.serviceTaskLaborTotal_error_msg = 'Total must be greater than 0';
                error = true;
            }
        }

        if(!error){
        if(index == 'create'){

            self.laborArr.push({
                lid: 0,
                // laborid: {value: serviceTaskLabor.value, text:serviceTaskLabor.text},
                service_task_id: {value: task.value, text:task.text, index: taskIndex},
                laborhours: self.serviceTaskLaborHour,
                laborhourrate: self.serviceTaskLaborHourRate,
                laborsubtotal: self.serviceTaskLaborSubTotal,
                labordescription: self.labor_description
            });

        }else{

            self.laborArr[index].lid = (self.serviceTaskLaborId != 0)?self.serviceTaskLaborId:0;
            // self.laborArr[index].laborid = {value: serviceTaskLabor.value, text:serviceTaskLabor.text};
            self.laborArr[index].service_task_id = {value: task.value, text:task.text, index: taskIndex};
            self.laborArr[index].laborhours = self.serviceTaskLaborHour;
            self.laborArr[index].laborhourrate = self.serviceTaskLaborHourRate;
            self.laborArr[index].laborsubtotal = self.serviceTaskLaborSubTotal;
            self.laborArr[index].labordescription = self.labor_description;

        }

        // do not allow Technician to create new labor...
        // permission related changes
        self.serviceTaskLaborId = 0;
        self.serviceTaskWoLaborId = 0;
        self.serviceTaskLaborIndex = 'create';

        self.calculateTotalAmount();

        self.clearLabor();
        self.showActiveTaskLabor = '';
        // self.isEditLabor = false;
        var itemFlag='labor';
        setTimeout(function () {

            self.CreateWoVendorEstimate('',itemFlag);

        }, 500);
        }
    },

    saveServiceTaskComp(serviceTaskComp, task, taskIndex){

        var self = this;
        var error = false;

        //add comp to compArr if added new..

        var index = self.serviceTaskCompIndex;

        self.serviceTaskComp_error_msg = '';

        if(serviceTaskComp == null){
            self.serviceTaskComp_error_msg = 'Specify Component';
            error = true;
        }

        if(!error){

            if(index == 'create'){

                self.compArr.push({
                    cid: 0,
                    compid: {value: serviceTaskComp.value, text:serviceTaskComp.text},
                    service_task_id: {value: task.value, text:task.text, index: taskIndex},
                    compcost: self.serviceTaskCompCost,
                    compquantity: self.serviceTaskCompQuantity,
                    compsubtotal: self.serviceTaskCompSubTotal,
                    compdescription: self.comp_description
                });

            }else{

                self.compArr[index].cid = (self.serviceTaskCompId != 0)?self.serviceTaskCompId:0;
                self.compArr[index].compid = {value: serviceTaskComp.value, text:serviceTaskComp.text};
                self.compArr[index].service_task_id = {value: task.value, text:task.text, index: taskIndex};
                self.compArr[index].compcost = self.serviceTaskCompCost;
                self.compArr[index].compquantity = self.serviceTaskCompQuantity;
                self.compArr[index].compsubtotal = self.serviceTaskCompSubTotal;
                self.compArr[index].compdescription = self.comp_description;

            }


            self.serviceTaskCompId = 0;
            self.serviceTaskWoCompId = 0;
            self.serviceTaskCompIndex = 'create';

            self.calculateTotalAmount();

            self.clearServiceTaskComp();
            self.showActiveTaskLabor = '';
            // self.isEditLabor = false;
            var itemFlag='component';
            setTimeout(function () {

                self.CreateWoVendorEstimate('',itemFlag);

            }, 500);

        }else{
          self.errorValidationFocus();
        }
    },

    editServiceTask(edit, index, serviceTaskIndex){
        var self = this;
        if(edit == 'labor'){

            self.serviceTaskLaborHour_error_msg = "";
            self.serviceTaskLaborDesc_error_msg = '';
            self.showActiveTaskLabor = 'addLabor'+serviceTaskIndex;

            // to do - remove labor from the laborArray.... already saved or not...
            // self.serviceTaskLabor = self.laborArr[index].laborid;
            self.serviceTaskLaborHour = self.laborArr[index].laborhours;
            self.serviceTaskLaborHourRate = self.laborArr[index].laborhourrate;
            self.serviceTaskLaborSubTotal = self.laborArr[index].laborsubtotal;

            self.labor_description = self.laborArr[index].labordescription;

            //to edit service task labor...
            self.serviceTaskLaborId = self.laborArr[index].lid;
            self.serviceTaskWoLaborId = self.laborArr[index].workOrderLaborId;
            self.serviceTaskLaborIndex = index;
            self.laborIndex = index;

        }else{

            self.showActiveTaskLabor = 'addComponent'+serviceTaskIndex;

            // to do - remove comp from the compArray.... already saved or not...

            self.serviceTaskComp = self.compArr[index].compid;
            self.serviceTaskCompCost = self.compArr[index].compcost;
            self.serviceTaskCompQuantity = self.compArr[index].compquantity;
            self.serviceTaskCompSubTotal = self.compArr[index].compsubtotal;

            self.comp_description = self.compArr[index].compdescription;

            //to edit service task labor...
            self.serviceTaskCompId = self.compArr[index].cid;
            self.serviceTaskWoCompId = self.compArr[index].workOrderCompId;
            self.serviceTaskCompIndex = index;

        }

    },

    clearComment(){

        var self = this;
        self.workOrderCommentId = 0;
        self.workOrderCId = 0;
        self.workOrderCommentIndex = 'create';
        self.comment_type_id = null;
        self.comment = '';

    },

    clearLabor(){

        var self = this;
        self.serviceTaskLaborSubTotal = 0;
        self.serviceTaskLaborHour = 0;
        self.serviceTaskLaborHourRate = 0;

        self.labor_description = '';


        self.serviceTaskLaborIndex = 'create';
        self.serviceTaskLaborId = 0;
        self.serviceTaskWoLaborId = 0;
        self.serviceTaskLaborDesc_error_msg = '';
        self.serviceTaskLaborHour_error_msg = '';
        self.serviceTaskLaborTotal_error_msg = '';
        // self.serviceTaskLabor = null;
        // self.isEditLabor = false;

        //permission related changes
        // $("#serviceTaskLabor").addClass("disable-field");
        // $("#serviceTaskLaborHour").addClass("disable-field");

    },

    clearServiceTaskComp(){

        var self = this;
        self.serviceTaskCompSubTotal = 0;
        self.serviceTaskCompQuantity = 0;
        self.serviceTaskCompCost = 0;

        self.comp_description = '';

        self.serviceTaskCompIndex = 'create';
        self.serviceTaskCompId = 0;
        self.serviceTaskWoCompId = 0;

        self.serviceTaskComp = null;
        self.serviceTaskComp_error_msg = '';

    },

    calculateTaxDiscountAmount(){
        var self = this;
        self.total_tax =  parseFloat((self.tax / 100) * self.parts_total);
        self.total_discount =  parseFloat((self.discount / 100) * self.sub_total);
        self.total = self.total_tax + parseFloat(self.sub_total) - self.total_discount;
    },

    calculateSubTotalForLabor(){

        var self = this;

        self.serviceTaskLaborSubTotal = 0;

        if((self.serviceTaskLaborHour &&  self.serviceTaskLaborHour > 0) || self.serviceTaskLaborHourRate ){
            self.serviceTaskLaborSubTotal = parseFloat(parseFloat(self.serviceTaskLaborHour).toFixed(2) * self.serviceTaskLaborHourRate);
            if(self.serviceTaskLaborSubTotal > 999999.99) {
              self.serviceTaskLaborHourRate_error_msg = "Amount value exceed";
              self.isDisableStore = true;
            } else {
              self.isDisableStore = false;
              self.serviceTaskLaborHourRate_error_msg = "";
            }
            // var hourTotal = self.serviceTaskLaborHour.split(':');

            // //labor per minute rate...

            // var perMinuteRate = self.serviceTaskLaborHourRate/60;

            // var lHourRate = parseFloat(hourTotal[0] * self.serviceTaskLaborHourRate);
            // console.log('lHourRate => '+lHourRate)

            // var lMinuteRate = 0;
            // if ( hourTotal[1]){

            //     lMinuteRate = parseFloat(hourTotal[1] * perMinuteRate);
            // }


            // self.serviceTaskLaborSubTotal = parseFloat(lHourRate + lMinuteRate);
            // console.log('serviceTaskLaborSubTotal => '+self.serviceTaskLaborSubTotal)

            // var hourTotal = self.serviceTaskLaborHour.split(':');

            // self.serviceTaskLaborSubTotal = parseFloat(self.serviceTaskLaborHourRate * hourTotal[0]);

        }

    },

    calculateSubTotalForComp(){

        var self = this;

        self.serviceTaskCompSubTotal = 0;

        if(self.serviceTaskCompCost || self.serviceTaskCompQuantity){

            self.serviceTaskCompSubTotal = parseFloat(self.serviceTaskCompCost * self.serviceTaskCompQuantity);

        }
    },

    calculateTotalAmount(){
        var self = this;

        self.labor_total = 0;
        self.parts_total = 0;
        self.sub_total = 0;

        // For Service Tasks
        var labor_charge=0, parts_charge=0, charge_amount=0, subtotal_val=0;

        for(var i=0;i<self.taskArr.length;i++)
        {
            if(self.taskArr[i].laboramount || self.taskArr[i].partamount) {

                //if labor and component does not have perticular task's index...

                subtotal_val = parseInt(self.taskArr[i].laboramount) + parseInt(self.taskArr[i].partamount);

                self.taskArr[i].subtotal = subtotal_val;

                if(self.taskArr[i].hasLabor != true){

                    labor_charge += (parseInt(self.taskArr[i].laboramount));

                }

                if(self.taskArr[i].hasComp != true){

                    parts_charge += (parseInt(self.taskArr[i].partamount));

                }

                if(self.taskArr[i].hasComp != true && self.taskArr[i].hasLabor != true){

                    charge_amount += subtotal_val;

                }else if(self.taskArr[i].hasComp == false && self.taskArr[i].hasLabor == true){

                    charge_amount += parts_charge;

                }else if(self.taskArr[i].hasComp == true && self.taskArr[i].hasLabor == false){

                    charge_amount += labor_charge;

                }

            }
        }

        //For Labor
        var labor_subtotal=0;

        for(var i=0;i<self.laborArr.length;i++)
        {

            if(self.laborArr[i].laborhours || self.laborArr[i].laborhourrate) {

                var hourTotal = self.laborArr[i].laborhours.split(':');

                //labor per minute rate...

                var perMinuteRate = self.laborArr[i].laborhourrate/60;

                var laborTotalHourRate = parseFloat(hourTotal[0] * self.laborArr[i].laborhourrate);
                console.log('laborTotalHourRate => '+laborTotalHourRate)

                var laborTotalMinuteRate = 0;
                if(hourTotal[1]){
                    laborTotalMinuteRate = parseFloat(hourTotal[1] * perMinuteRate);
                }

                console.log('laborTotalMinuteRate => '+laborTotalMinuteRate)

                labor_charge += parseFloat(laborTotalHourRate + laborTotalMinuteRate);
                labor_subtotal = parseFloat(laborTotalHourRate + laborTotalMinuteRate);
                console.log('labor_subtotal => '+labor_subtotal)

                self.laborArr[i].laborsubtotal = labor_subtotal;

                charge_amount += labor_subtotal;

            }
        }

        //For Component
        var comp_subtotal=0;

        for(var i=0;i<self.compArr.length;i++)
        {
            if(self.compArr[i].compquantity || self.compArr[i].compcost) {

                parts_charge += parseFloat(self.compArr[i].compquantity * self.compArr[i].compcost);

                comp_subtotal = parseFloat(self.compArr[i].compquantity * self.compArr[i].compcost);

                self.compArr[i].compsubtotal = comp_subtotal;

                charge_amount += comp_subtotal;

            }
        }

        self.labor_total+=labor_charge;
        self.parts_total+=parts_charge;
        self.sub_total+=charge_amount;
        self.calculateTaxDiscountAmount();

    },

    taskchange(evt){
        var self = this;
        self.activityActive = '';
        self.showTab = 'labor';
        self.serviceTaskActive = 'active';

        var index = self.taskArr.length - 1;

        if( evt != null ) {
            console.log("task change to "+JSON.stringify(evt))
            if(self.taskArr.length < 1){

                self.taskArr.push({
                    woiId: 0,
                    taskid: null,
                    component_category_id: null,
                    wi_reason_id: null,
                    defect_id: null,
                    woicomplaint: '',
                    woicause: '',
                    woicorrection: '',
                    laboramount: 0,
                    partamount: 0,
                    subtotal: 0,
                    hasLabor: false,
                    hasComp: false,
                    hasComment: false,
                    workOrderItemId:0
                });

                //in order to show entire line item on add line item button click...
                self.activeLineItemIdx = self.taskArr.length-1;

            }else{
                //work order line items validations
                $("#component_category_id" + index + " .dropdown-toggle").removeClass('border-red');
                $("#taskid" + index + " .dropdown-toggle").removeClass('border-red');

                $("#woicomplaint" + index).removeClass('border-red');
                $("#woicause" + index).removeClass('border-red');
                $("#woicorrection" + index).removeClass('border-red');

                if ( evt != 'mounted' ) {

                    if(self.taskArr[index].taskid != null && self.taskArr[index].component_category_id != null) {

                        self.taskArr.push({
                            woiId: 0,
                            taskid: null,
                            component_category_id: null,
                            wi_reason_id: null,

                            defect_id: null,
                            woicomplaint: '',
                            woicause: '',
                            woicorrection: '',
                            laboramount: 0,
                            partamount: 0,
                            subtotal: 0,
                            hasLabor: false,
                            hasComp: false,
                            hasComment: false,
                            workOrderItemId:0
                        });

                        //in order to show entire line item on add line item button click...
                        self.activeLineItemIdx = self.taskArr.length-1;


                    }else{
                        //validation for tasks
                        for(var i=0;i<self.taskArr.length;i++){
                            if (self.taskArr[i].component_category_id == null || !self.taskArr[i].component_category_id.value) {
                                $("#component_category_id" + i + " .dropdown-toggle").addClass('border-red');
                            }
                            if (self.taskArr[i].taskid == null || !self.taskArr[i].taskid.value) {
                                $("#taskid" + i + " .dropdown-toggle").addClass('border-red');
                            }

                            // if (self.taskArr[i].woicomplaint == "" || self.taskArr[i].woicomplaint == '') {
                            //     $("#woicomplaint" + i).addClass('border-red');
                            // }
                            // if (self.taskArr[i].woicause == "" || self.taskArr[i].woicause == '') {
                            //     $("#woicause" + i).addClass('border-red');
                            // }
                            // if (self.taskArr[i].woicorrection == "" || self.taskArr[i].woicorrection == '') {
                            //     $("#woicorrection" + i).addClass('border-red');
                            // }
                        }
                    }
                }
            }
            // In order to map labor/component with task..
            self.serviceTaskArr.push({value: evt.value, text:evt.text, index: self.taskArr.length-1});
            console.log('serviceTaskArr value here => '+JSON.stringify(self.serviceTaskArr))
        }

        self.task_id = {};
    },

    BackVendorEstimateList() {
      var self = this;

      // remove localStorage value
      localStorage.removeItem('newAsset');
      localStorage.removeItem('newCustomer');

      if( self.fromWOFlag){
          var url = "/workorder/view/"+self.fromWorkorderId;
          self.$router.push(url);
          return;
      }

      self.$router.push({ name: 'EstimateMainList', query: { active: 'vendor' }})
    },

    onSearchPurchaseOrder(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'purchase_order', '');
        }
    },
    onSearchAsset(search, loading) {
        var self = this;

        // use this in order to create new asset...
        self.searchedAsset = search;
        if (search.length > 3) {
            loading(true);
            self.searchField(loading, search, 'vehicle');
        }else{
            self.isAssetNotFound = false;
        }

    },
    onSearchVendor(search, loading) {
        var self = this;

        // use this in order to create new customer...
        self.searchedCustomer = search;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'vendor', '');
        }else{
            self.isCustomerNotFound = false;
        }
    },
    onSearchUser(search, loading) {
        var self = this;
        if (search.length > 0) {

            loading(true);
            self.searchField(loading, search, 'user', '');
        }
    },

    callCreateWoVendorEstimateAPI(fields, segments, flag) {
        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/vendor-estimate/create",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                // remove localStorage value
                localStorage.removeItem('newAsset');
                localStorage.removeItem('newCustomer');

                if ($('#vehicle_select').hasClass('disable-field')) {
                    $('#vehicle_select').removeClass('disable-field');
                }

                if (segments[3])
                {
                    $("#createWorkOrderBtn").val("Update");
                    $("#createWorkOrderBtn").prop("disabled", false);
                    $("#cancelWorkOrderBtn").prop("disabled",false);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueWorkOrderBtn").val("Save and Continue");
                        $("#createWorkOrderBtn").prop("disabled", false);
                        $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                        $("#cancelWorkOrderBtn").prop("disabled",false);

                    }else{

                        $("#createWorkOrderBtn").val("Save");
                        $("#createWorkOrderBtn").prop("disabled", false);
                        $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                        $("#cancelWorkOrderBtn").prop("disabled",false);

                    }
                }
                if (data.status == "success") {
//                    console.log("check flag :"+flag);

                    if (flag == "Save and Continue") {

                        $("#VendorWoEstimateForm").trigger("reset");
                        self.vehicle_id = null;
                        self.customer_id = null;
                        self.vendor_id = null;

                        self.dropZonePreviewFiles=[];
                        self.open_date = moment().format('MM/DD/YYYY hh:mm:ss a');
                        self.requested_completion = "";
                        self.agreed_date = "";
                        self.expiry_date = "";

                        self.user_id = self.loggedInUser;
                        self.reason_id = null;
                        self.priority = null;

                        self.maintenance_type_id = null;

                        self.miles = null;

                        self.itemArr=[];

                        //For Work Order Line Item

                        self.extraLaborComp = false;
                        self.woiDetail = [];
                        self.woLaborDetail = [];
                        self.woCompDetail = [];
                        self.woComment = [];

                        self.showActiveTaskLabor = '';

                        self.serviceTaskComp_error_msg = '';
                        self.serviceTaskCompIndex = 'create';
                        self.serviceTaskCompId = 0;
                        self.serviceTaskWoCompId = 0;
                        self.serviceTaskComp = null;
                        self.serviceTaskCompQuantity = 0;
                        self.serviceTaskCompCost = 0;
                        self.serviceTaskCompSubTotal = 0;

                        self.serviceTaskCnt = 0;
                        self.laborCnt = 0;
                        self.componentCnt = 0;

                        self.serviceTaskLaborIndex = 'create';
                        self.serviceTaskLaborId = 0;
                        self.serviceTaskWoLaborId = 0;
                        // self.serviceTaskLabor = null;
                        self.serviceTaskLaborHour = 0;
                        self.serviceTaskLaborHourRate = 0;
                        self.serviceTaskLaborSubTotal = 0;

                        self.serviceTaskArr = [];

                        self.showTab = 'labor';
                        self.serviceTaskActive = "active";
                        self.laborActive = "";
                        self.partActive = "";
                        self.activityActive = "";
                        self.showActivity = '';

                        self.taskArr = [];
                        self.parts_total = 0;
                        self.labor_total = 0;
                        self.sub_total = 0;
                        self.tax = 0;
                        self.total_tax = 0;
                        self.discount = 0;
                        self.total_discount = 0;
                        self.total = 0;
                        self.wonotes = "";
                        self.wostatus = {
                            value: "open" ,
                            text: "Open"
                        },

                        //labor tab related
                        self.laborArr = [];
                        self.labor_id = null;

                        //part tab related
                        self.comp_id = null;
                        self.compArr = [];

                        //show display line item....
                        self.displayLineItem = true;
                        //save work order id to save work order line item and more
                        // self.woId = data.content.id;
                        self.woId = 0;
                        self.estimate_no = '';
                        self.estimate_amount = '';
                        self.$refs.dropzone.removeAllFiles();
                        // self.loadWoVendorEstimate();

                    }else if(flag == "final"){
                        self.woId = data.content.id;
                        if (self.fromWorkorderId > 0){
                            // self.$router.push('/vendor-estimate/view/'+data.content.id)
                            self.$router.push('/vendor-estimate/view/'+data.content.id+'?from=wo-'+self.fromWorkorderId);
                            // self.$router.push({ name: 'VendorEstimateView',params:{id:data.content.id}, query:{from:'wo-'+self.fromWorkorderId}});
                        }else{

                            self.$router.push({ name: 'VendorEstimateView',params:{id:data.content.id}});

                        }
                        //self.$router.push({ name: 'EstimateMainList', query: { active: 'vendor' }})
                    }else {

                        self.woId = data.content.id;
                        self.$refs.dropzone.removeAllFiles(true);
                        self.loadWoVendorEstimate();
                        self.woVendorEstimateItemData();
                    }

                } else {
                    if (data.content.length > 0) {
                        var err = "";
                        for (var i = 0; i < data.content.length; i++) {
                            err += data.content[i] + "<br>";
                        }
                        $("#errorMsg").html(err);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (segments[3])
                {
                    $("#createWorkOrderBtn").val("Update");
                    $("#createWorkOrderBtn").prop("disabled", false);
                    $("#cancelWorkOrderBtn").prop("disabled",false);
                } else {
                    if (flag == "Save and Continue") {

                        $("#VendorWoEstimateForm").trigger("reset");


                        $("#createAndContinueWorkOrderBtn").val("Save and Continue");
                        $("#createWorkOrderBtn").prop("disabled", false);
                        $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                        $("#cancelWorkOrderBtn").prop("disabled",false);

                    }else{

                        $("#createWorkOrderBtn").val("Save");
                        $("#createWorkOrderBtn").prop("disabled", false);
                        $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                        $("#cancelWorkOrderBtn").prop("disabled",false);

                    }
                }
                self.generateStatusCodeMessage(jqXHR, false,'vendor-estimate-create');
            }
        });

    },

    callCreateWoVendorEstimateItemAPI(fields, segments, flag) {
        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/vendor-estimate-item/create",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (segments[3])
                {
                    $("#createWorkOrderBtn").val("Update");
                    $("#createWorkOrderBtn").prop("disabled", false);
                    $("#cancelWorkOrderBtn").prop("disabled",false);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueWorkOrderBtn").val("Save and Continue");
                        $("#createWorkOrderBtn").prop("disabled", false);
                        $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                        $("#cancelWorkOrderBtn").prop("disabled",false);

                    }else{

                        $("#createWorkOrderBtn").val("Save");
                        $("#createWorkOrderBtn").prop("disabled", false);
                        $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                        $("#cancelWorkOrderBtn").prop("disabled",false);

                    }
                }
                if (data.status == "success") {

                    if(flag == "final"){
                        //self.$router.push({ name: 'EstimateMainList', query: { active: 'vendor' }})
                        if (self.fromWorkorderId > 0){
                            self.$router.push('/vendor-estimate/view/'+data.content.id+'?from=wo-'+self.fromWorkorderId);
                            // self.$router.push({ name: 'VendorEstimateView',params:{id:data.content.id}, query:{from:'wo-'+self.fromWorkorderId}});
                        }else{
                            self.$router.push({ name: 'VendorEstimateView',params:{id:data.content.id}});
                        }
                    }else {

                        self.woVendorEstimateItemData();
                    }

                } else {
                    if (data.content.length > 0) {
                        var err = "";
                        for (var i = 0; i < data.content.length; i++) {
                            err += data.content[i] + "<br>";
                        }
                        $("#errorMsg").html(err);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (segments[3])
                {
                    $("#createWorkOrderBtn").val("Update");
                    $("#createWorkOrderBtn").prop("disabled", false);
                    $("#cancelWorkOrderBtn").prop("disabled",false);
                } else {
                    if (flag == "Save and Continue") {

                        $("#VendorWoEstimateForm").trigger("reset");


                        $("#createAndContinueWorkOrderBtn").val("Save and Continue");
                        $("#createWorkOrderBtn").prop("disabled", false);
                        $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                        $("#cancelWorkOrderBtn").prop("disabled",false);

                    }else{

                        $("#createWorkOrderBtn").val("Save");
                        $("#createWorkOrderBtn").prop("disabled", false);
                        $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                        $("#cancelWorkOrderBtn").prop("disabled",false);

                    }
                }
                self.generateStatusCodeMessage(jqXHR, true,'vendor-estimate-items-create');
            }
        });

    },

    CreateWoVendorEstimate(flag,itemFlag) {



        var self = this;
        var error = false;
        self.vehicle_error_msg = "";
        self.estimate_no_error_msg = "";
        self.miles_error_msg = "";
        self.estimate_amount_error_msg = "";
        self.maintenance_type_error_msg = "";
        self.customer_error_msg = "";
        self.location_error_msg = "";
        self.user_error_msg = "";
        self.reason_error_msg = "";
        self.expiry_date_error_msg = "";
        self.open_date_error_msg = "";

        var checkNumber = /^[0-9]+(\.[0-9]+)?$/;

        // if (self.estimate_no == null || self.estimate_no == "") {
        //     self.estimate_no_error_msg = "Estimate No Required.";
        //     error = true;
        // }

        if (self.vehicle_id == null || !self.vehicle_id.value) {
            self.vehicle_error_msg = "Unit Required.";
            error = true;
        }

        // if (self.miles == null || self.miles == "") {
        //     self.miles_error_msg = "Miles Required.";
        //     error = true;
        // } else {

        //     //check amount is valid or not
            if (self.miles && !String(self.miles).match(checkNumber) ) {
                self.miles_error_msg = "Miles is not valid.";
                error = true;
            }
        // }

        if (self.estimate_amount == null || self.estimate_amount == "") {
            self.estimate_amount_error_msg = "Estimate Amount Required.";
            error = true;
        } else {

            //check amount is valid or not
            if ( !String(self.estimate_amount).match(checkNumber) ) {
                self.estimate_amount_error_msg = "Estimate Amount is not valid.";
                error = true;
            }
        }

        if (self.maintenance_type_id == null || !self.maintenance_type_id.value) {
            self.maintenance_type_error_msg = "Maintenance Type Required.";
            error = true;
        }

        if (self.open_date == null || self.open_date == "") {
            self.open_date_error_msg = "Open Date Required.";
            error = true;
        }

        if (self.expiry_date == null || self.expiry_date == "") {
            self.expiry_date_error_msg = "Expiry Date Required.";
            error = true;
        }

        if (self.open_date != "" && self.open_date != null && self.expiry_date != "" && self.expiry_date != null){

            if (new Date(self.open_date) > new Date(self.expiry_date)) {
                self.expiry_date_error_msg = "Expiry Date should not be earlier than Open Date.";
                error = true;
            }
        }

        if (self.vendor_id == null || !self.vendor_id.value) {
            self.customer_error_msg = "Vendor Required.";
            error = true;
        }

        // if (self.location_id == null || !self.location_id.value) {
        //     self.location_error_msg = "Location Required.";
        //     error = true;
        // }

        if (self.user_id == null || !self.user_id.value) {
            self.user_error_msg = "User Required.";
            error = true;
        }
        //work order line items validations
        // if(self.displayLineItem){
            for (var i=0; i<self.taskArr.length; i++) {

                $("#component_category_id" + i + " .dropdown-toggle").removeClass('border-red');
                $("#taskid" + i + " .dropdown-toggle").removeClass('border-red');

                $("#woicomplaint" + i).removeClass('border-red');
                $("#woicause" + i).removeClass('border-red');
                $("#woicorrection" + i).removeClass('border-red');

                if (self.taskArr[i].component_category_id == null || !self.taskArr[i].component_category_id.value) {
                    $("#component_category_id" + i + " .dropdown-toggle").addClass('border-red');
                     $([document.documentElement, document.body]).animate({
                                scrollTop: $("#component_category_id" + i).offset().top-300
                         }, 500);
                    error = true;
                }
                if (self.taskArr[i].taskid == null || !self.taskArr[i].taskid.value) {
                    $("#taskid" + i + " .dropdown-toggle").addClass('border-red');
                    $([document.documentElement, document.body]).animate({
                                scrollTop: $("#taskid" + i).offset().top-300
                         }, 500);
                    error = true;
                }

                // if (self.taskArr[i].woicomplaint == "" || self.taskArr[i].woicomplaint == '') {
                //     $("#woicomplaint" + i).addClass('border-red');
                //     error = true;
                // }
                // if (self.taskArr[i].woicause == "" || self.taskArr[i].woicause == '') {
                //     $("#woicause" + i).addClass('border-red');
                //     error = true;
                // }
                // if (self.taskArr[i].woicorrection == "" || self.taskArr[i].woicorrection == '') {
                //     $("#woicorrection" + i).addClass('border-red');
                //     error = true;
                // }
            }
        // }

      if (!error) {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");

            var workOrderItemIdArr = [];
            var taskIdArr = [];
            var laborAmountArr = [];
            var partAmountArr = [];

            self.woiDetail = [];
            self.woLaborDetail = [];
            self.woCompDetail = [];
            self.woComment = [];

            // if(self.displayLineItem){

                console.log('now collect task array info...');
                for(var i = 0; i<self.taskArr.length; i++){

                    self.woiDetail.push({

                        wo_id: segments[3],
                        wo_item_id: self.taskArr[i].woiId,
                        task_id: self.taskArr[i].taskid.value,
                        labor_amount: (self.taskArr[i].laboramount != undefined)?self.taskArr[i].laboramount:0,
                        component_amount: (self.taskArr[i].partamount != undefined)?self.taskArr[i].partamount:0,
                        component_category_id: self.taskArr[i].component_category_id.value,
                        wi_reason_id: (self.taskArr[i].wi_reason_id != undefined)?self.taskArr[i].wi_reason_id.value:null,
                        standard_defect_id: (self.taskArr[i].defect_id != undefined)?self.taskArr[i].defect_id.value:null,
                        complaint: self.taskArr[i].woicomplaint,
                        cause: self.taskArr[i].woicause,
                        correction: self.taskArr[i].woicorrection,
                        work_order_item_id: self.taskArr[i].workOrderItemId

                    });

                }
            // }
            // self.woLaborDetail[] = [];
            for(var i = 0; i<self.laborArr.length; i++){

                var sTaskId = (self.laborArr[i].service_task_id != null)?self.laborArr[i].service_task_id.value:0;
                //to do
                //if labor is not assigned with any task then ... assigned it to last wo task index
                var sTaskIndex = (self.laborArr[i].service_task_id != null)?self.laborArr[i].service_task_id.index:self.woiDetail.length;


                self.woLaborDetail.push({

                    work_order_labor_id: self.laborArr[i].lid,
                    service_task_id: sTaskId,
                    service_task_index: sTaskIndex,
                    // user_id: self.laborArr[i].laborid.value,
                    labor_hours: parseFloat(self.laborArr[i].laborhours).toFixed(2),
                    labor_hourly_rate: self.laborArr[i].laborhourrate,
                    sub_total: self.laborArr[i].laborsubtotal,
                    notes: self.laborArr[i].labordescription,
                    wo_labor_id: self.laborArr[i].workOrderLaborId

                });


                self.woLaborDetail[i]['laborHour'] = [];


                if(sTaskId == 0){
                    self.extraLaborComp = true;
                }

            }

            for(var i = 0; i<self.compArr.length; i++){

                var sTaskId = (self.compArr[i].service_task_id != null)?self.compArr[i].service_task_id.value:0;
                var sTaskIndex = (self.compArr[i].service_task_id != null)?self.compArr[i].service_task_id.index:self.woiDetail.length;

                self.woCompDetail.push({

                    work_order_comp_id: self.compArr[i].cid,
                    service_task_id: sTaskId,
                    service_task_index: sTaskIndex,
                    component_id: self.compArr[i].compid.value,
                    quantity: self.compArr[i].compquantity,
                    unit_cost: self.compArr[i].compcost,
                    sub_total: self.compArr[i].compsubtotal,
                    notes: self.compArr[i].compdescription,
                    wo_comp_id: self.compArr[i].workOrderCompId

                });

                if(sTaskId == 0){
                    self.extraLaborComp = true;
                }

            }

            for(var i = 0; i<self.commentArr.length; i++){

                var sTaskId = (self.commentArr[i].service_task_id != null)?self.commentArr[i].service_task_id.value:0;
                var sTaskIndex = (self.commentArr[i].service_task_id != null)?self.commentArr[i].service_task_id.index:self.woiDetail.length;

                self.woComment.push({

                    work_order_comment_id: self.commentArr[i].wocId,
                    service_task_id: sTaskId,
                    service_task_index: sTaskIndex,
                    comment: self.commentArr[i].woc,
                    comment_type_id: (self.commentArr[i].wocType != null)?self.commentArr[i].wocType.value:null,
                    //we are not using below to property backend side...
                    comment_by: (self.commentArr[i].wocBy != null)?self.commentArr[i].wocBy.value:null,
                    comment_at: self.commentArr[i].wocAt,
                    wo_comment_id: self.commentArr[i].woCommentId

                });

            }

            if(self.extraLaborComp){
                //to do
                self.woiDetail.push({

                    wo_id: segments[3],
                    wo_item_id: 0,
                    task_id: null,
                    standard_defect_id: null,
                    labor_amount: 0,
                    component_amount: 0,
                    notes: ''

                });

            }

            if (segments[3])
            {
                $("#createWorkOrderBtn").val("Updating ...");
                $("#createWorkOrderBtn").prop("disabled", true);
                $("#cancelWorkOrderBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueWorkOrderBtn").val("Saving ...");
                    $("#createWorkOrderBtn").prop("disabled", true);
                    $("#createAndContinueWorkOrderBtn").prop("disabled", true);
                    $("#cancelWorkOrderBtn").prop("disabled",true);

                }else{

                    $("#createWorkOrderBtn").val("Saving ...");
                    $("#createWorkOrderBtn").prop("disabled", true);
                    $("#createAndContinueWorkOrderBtn").prop("disabled", true);
                    $("#cancelWorkOrderBtn").prop("disabled",true);
                }

            }

            var fields = $("#VendorWoEstimateForm").serializeArray();

            fields.push({name: "vehicle_id", value: self.vehicle_id.value});
            // fields.push({name: "customer_id", value: self.customer_id.value});
            fields.push({name: "vendor_id", value: self.vendor_id.value});
            if(self.location_id && self.location_id.value){

                fields.push({name: "location_id", value: self.location_id.value});

            }else{

                fields.push({name: "location_id", value:''});
            }
            fields.push({name: "maintenance_type_id", value: self.maintenance_type_id.value});
            fields.push({name: "user_id", value: self.user_id.value});
            if(self.priority == null){
                fields.push({name: "priority", value: ""});
            }else{
                fields.push({name: "priority", value: self.priority.value});
            }

            fields.push({name: "id", value: (segments[3] != undefined)?segments[3]:self.woId});

            // PR - Work Order Table

            fields.push({name: "wo_labor_total", value: self.labor_total});
            fields.push({name: "wo_comp_total", value: self.parts_total});
            fields.push({name: "wo_sub_total", value: self.sub_total});
            fields.push({name: "wo_discount", value: self.discount});
            fields.push({name: "wo_total_discount", value: self.total_discount});
            fields.push({name: "wo_tax", value: self.tax});
            fields.push({name: "wo_total_tax", value: self.total_tax});
            fields.push({name: "wo_total", value: self.total});
            fields.push({name: "wo_status", value: self.wostatus.value});
            fields.push({name: "wo_description", value: self.wonotes});

            // PR - Work Order Item Changes

            fields.push({name: "from_wo_id", value: self.fromWorkorderId});
            fields.push({name: "work_order_item_details", value: JSON.stringify(self.woiDetail)});
            fields.push({name: "labor_details", value: JSON.stringify(self.woLaborDetail)});
            fields.push({name: "component_details", value: JSON.stringify(self.woCompDetail)});
            fields.push({name: "comment_details", value: JSON.stringify(self.woComment)});
            fields.push({name: "item_flag", value: itemFlag});

          if(self.files.length > 0 ){
                fields.push({name: "doc_path", value: JSON.stringify(self.files)});
            }else{
                fields.push({name: "doc_path", value: null});
            }

            console.log(fields);
            // if(self.displayLineItem){

            //     self.callCreateWoVendorEstimateItemAPI(fields, segments, flag);

            // }else{

                self.callCreateWoVendorEstimateAPI(fields, segments, flag);

            // }



      }else{
          self.errorValidationFocus();
        }

    },

    loadWoVendorEstimate() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;


        let wo_id = (segments[3] != undefined)?segments[3]:self.woId;

        $.ajax({
            url: process.env.ROOT_API + "/vendor-estimate/" + wo_id,
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {

                    self.estimate_no = data.content.vendor_estimate_no;
                    self.estimate_amount = data.content.estimate_amount;
                    self.estimateAmountInfo = data.content.estimate_amount;
                    self.estimateNoInfo = data.content.vendor_estimate_no;

                    if(data.content.vehicle_id != null){
                        var vehicleData = self.titleCase(data.content.vUnitNo);
                        if(data.content.vtCode != null){
                            vehicleData += " | " + self.titleCase(data.content.vtCode);
                        }
                        if(data.content.vName != null){
                            vehicleData += " | " + self.titleCase(data.content.vName);
                        }
                        self.vehicle_id = {value: data.content.vehicle_id, text: vehicleData};
                        self.assetInfo = vehicleData;

                    }else{
                        self.vehicle_id = null;
                    }

                    self.open_date = data.content.open_date;
                    self.openDateInfo = data.content.open_date;
                    self.requested_completion = data.content.requested_completion;
                    self.requestCompInfo = data.content.requested_completion;
                    self.agreed_date = data.content.agreed_date;
                    self.expiry_date = data.content.expiry_date;
                    self.expiryDateInfo = data.content.expiry_date;
                    self.agreedDateInfo = data.content.agreed_date;
                    // self.customer_id = {value: data.content.customer_id , text : self.titleCase(data.content.cusName) + " (" + data.content.cusCode + ")"};

                    self.vendor_id = {value: data.content.vendor_id , text : self.titleCase(data.content.venName) + " (" + data.content.venCode + ")"};
                    // self.customerInfo = self.titleCase(data.content.cusName) + " (" + data.content.cusCode + ")";
                    self.VendorInfo = self.titleCase(data.content.venName) + " (" + data.content.venCode + ")";

                    if(data.content.uLastName != null){
                        self.user_id = {value: data.content.user_id, text: self.titleCase(data.content.uFirstName) + " " + self.titleCase(data.content.uLastName)};
                        self.userInfo = self.titleCase(data.content.uFirstName) + " " + self.titleCase(data.content.uLastName);
                    }else{
                        self.user_id = {value: data.content.user_id, text: self.titleCase(data.content.uFirstName)};
                        self.userInfo = self.titleCase(data.content.uFirstName);
                    }

                    self.reason_id = {value: data.content.reason_id , text: self.titleCase(data.content.rName) + " (" + data.content.rCode + ")"};
                    if ( data.content.priority ) {
                        self.priority = {value: data.content.priority, text: data.content.priorityName + " (" + data.content.priority + ")"};
                        self.priorityInfo = data.content.priorityName + " (" + data.content.priority + ")";
                    } else {
                        self.priority = null;
                    }

                    self.woStatusInfo = self.titleCase(data.content.status);
                    self.milesInfo = data.content.miles;

                    self.maintenanceTypeInfo = self.titleCase(data.content.maintenanceTypeName);
                    self.wostatus = {value: data.content.status, text: self.formatString(data.content.status)};
                    if(data.content.lState != null){
                        self.locationInfo = data.content.lName + ", " + data.content.lState + " | " + data.content.lCode;
                    }else{
                        self.locationInfo = data.content.lName + " | " + data.content.lCode;
                    }

                    self.wonotes = data.content.description;
                    self.woNotesInfo = data.content.description;

                    if(data.content.location_id){
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.lName)+' | '+data.content.lCode };
                    }

                    if(data.content.maintenanceTypeId){
                        self.maintenance_type_id = {value: data.content.maintenanceTypeId, text: self.titleCase(data.content.maintenanceTypeName)};
                    }

                    self.tax = data.content.tax;
                    self.total_tax = data.content.tax_amount;

                    self.miles = data.content.miles;

                    self.discount = data.content.discount;
                    self.total_discount = data.content.discount_amount;

                    self.total = data.content.total_amount;

                    if(data.content.doc_path != null) {
                        self.dropZonePreviewFiles = data.content.doc_path;
                    }

//                    self.loadFilesPreview();
                    self.woVendorEstimateItemData();

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, false,'get-vendor-estimate-details');
            }
        });
    },
    getVendorEstimateNo() {
        let self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/vendor-estimate/number",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.estimate_no = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, true, 'get-reservation-number');
            }
        });
    
    },
    getCurrentDateTime(){
        var today = new Date();

        var dd = today.getDate();
        var mm = today.getMonth()+1;
        var yyyy = today.getFullYear();

        var HH = today.getHours();
        var MM = today.getMinutes();
        var SS = today.getSeconds();

        if(dd<10)
        {
            dd='0'+dd;
        }

        if(mm<10)
        {
            mm='0'+mm;
        }

        if(HH<10)
        {
            HH='0'+HH;
        }

        if(MM<10)
        {
            MM='0'+MM;
        }

        if(SS<10)
        {
            SS='0'+SS;
        }

        var date = mm+'/'+dd+'/'+yyyy;
        var time = HH + ":" + MM + ":" + SS;

        today = date + " " + time;
        return today;
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    formatString(data) {
        var self = this;
        var value = data.replace(/_/g, " ");
        var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
            return letter.toUpperCase();
        });
        return upp;
    },

    onSearchComponent(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'component', '');
        }
    },

    removeLine (removeFrom,index) {
        console.log('eror pr = '+index)
        var self = this;

        var removeLaborArr = [];
        var removeCompArr = [];

        if(removeFrom == 'task'){

            if (self.taskArr[index].woiId == 0) {

                self.taskArr.splice(index, 1);

                // Remove Service Task from the Service Task selection
                self.serviceTaskArr.splice(index, 1);

                // PR - Remove Labor assigned to perticular Service Task

                for ( var i = 0; i < self.laborArr.length; i++ ) {

                    if(self.laborArr[i].service_task_id != null){

                        if(self.laborArr[i].service_task_id.index == index){

                            removeLaborArr.push(i);

                        }

                    }

                }

                for (var i = removeLaborArr.length -1; i >= 0; i--) {

                    self.laborArr.splice(removeLaborArr[i],1);

                }

                // PR - Remove Component assigned to perticular Service Task

                for ( var j = 0; j < self.compArr.length; j++ ) {

                    if(self.compArr[j].service_task_id != null){

                        if(self.compArr[j].service_task_id.index == index){
                            removeCompArr.push(j);

                        }

                    }

                }

                for (var i = removeCompArr.length -1; i >= 0; i--) {

                    self.compArr.splice(removeCompArr[i],1);

                }


                self.manageLaborCompIndex(index);
                self.calculateTotalAmount();

            }else{
                //remove work order line item task
                self.removeWoVendorEstimateLineItem('task',self.taskArr[index].woiId,index);
            }

        }else if(removeFrom == 'labor'){

            if (self.laborArr[index].lid == 0) {

                if( self.laborArr[index].service_task_id != null){
                    var taskIndex = self.laborArr[index].service_task_id.index;
                    var lSubtotal = self.laborArr[index].laborsubtotal;

                    self.taskArr[taskIndex].laboramount = self.taskArr[taskIndex].laboramount - lSubtotal;
                    self.taskArr[taskIndex].subtotal = self.taskArr[taskIndex].subtotal - lSubtotal;

                    // TO DO :
                    if(self.taskArr[taskIndex].laboramount == 0){
                        // if ($('#laboramount'+taskIndex).hasClass('disable-field')) {
                        //     $("#laboramount"+taskIndex).removeClass("disable-field");
                        // }
                        self.taskArr[taskIndex].hasLabor = false;
                    }
                }

                self.laborArr.splice(index, 1);
                self.calculateTotalAmount();

            }else{
                //remove work order line item labor
                self.removeWoVendorEstimateLineItem('labor',self.laborArr[index].lid,index);
            }

        }else if(removeFrom == 'component'){

            if (self.compArr[index].cid == 0) {

                if( self.compArr[index].service_task_id != null){
                    var taskIndex = self.compArr[index].service_task_id.index;
                    var cSubtotal = self.compArr[index].compsubtotal;

                    self.taskArr[taskIndex].partamount = self.taskArr[taskIndex].partamount - cSubtotal;
                    self.taskArr[taskIndex].subtotal = self.taskArr[taskIndex].subtotal - cSubtotal;

                    // TO DO :
                    if(self.taskArr[taskIndex].partamount == 0){
                        // if ($('#partamount'+taskIndex).hasClass('disable-field')) {
                        //     $("#partamount"+taskIndex).removeClass("disable-field");
                        // }
                        self.taskArr[taskIndex].hasComp = false;
                    }
                }

                self.compArr.splice(index, 1);
                self.calculateTotalAmount();

            }else{
                //remove work order line item component
                self.removeWoVendorEstimateLineItem('component',self.compArr[index].cid,index);
            }

        }

    },

    manageLaborCompIndex( index ){
        var self = this;

        for ( var i = 0; i < self.laborArr.length; i++ ) {
            if(self.laborArr[i].service_task_id != null){
                if(self.laborArr[i].service_task_id.index > index){
                    self.laborArr[i].service_task_id.index = self.laborArr[i].service_task_id.index - 1;
                }
            }
        }

        for ( var j = 0; j < self.compArr.length; j++ ) {
            if(self.compArr[j].service_task_id != null){
                if(self.compArr[j].service_task_id.index > index){
                    self.compArr[j].service_task_id.index = self.compArr[j].service_task_id.index - 1;
                }
            }
        }

        //serviceTaskArr

        for ( var k = 0; k < self.serviceTaskArr.length; k++ ) {
            if(self.serviceTaskArr[k].index > index){
                self.serviceTaskArr[k].index = self.serviceTaskArr[k].index - 1;
            }
        }

    },
    woVendorEstimateItemData() {

        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        let wo_id = (segments[3] != undefined)?segments[3]:self.woId;

        //unbind jScrollPane
        setTimeout(function () {
                $(function(){
                    var pane = $('.comment-list-btm');
                    pane.jScrollPane();
                    var api = pane.data('jsp');
                    if(api != undefined){
                        api.destroy();
                    }

                    //activity jScrollPane
                    var paneActivity = $('.activity-list-btm');
                    paneActivity.jScrollPane();
                    var apiActivity = paneActivity.data('jsp');
                    if(apiActivity != undefined){
                        apiActivity.destroy();
                    }
                });
        },200);

        $.ajax({
            url: process.env.ROOT_API + "/vendor-estimate/get-vendor-estimate-item",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType:"json",
            data:{
                wo_vendor_id: wo_id,
            },
            success: function (data) {

                if (data.code == 200) {

                    self.taskArr = [];
                    self.compArr = [];
                    self.laborArr = [];
                    self.commentArr = [];
                    self.activityArr = [];

                    if(data.content.item != undefined){
                        self.serviceTaskArr = []

                        for ( var i=0; i<data.content.item.length; i++ ) {

                            self.taskArr.push({

                                workOrderItemId:0,
                                // wo_id: (data.content[i].wo_id != undefined && data.content[i].wo_id != null && data.content[i].wo_id != '')?data.content[i].wo_id:0,
                                woiId: (data.content.item[i].wo_item_id != undefined && data.content.item[i].wo_item_id != null && data.content.item[i].wo_item_id != '')?data.content.item[i].wo_item_id:0,
                                taskid: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '')?{value: data.content.item[i].task_id, text: self.titleCase(data.content.item[i].task_name + " (" + data.content.item[i].task_code +")")}:null,
                                laboramount: data.content.item[i].labor_amount,
                                partamount: data.content.item[i].component_amount,
                                component_category_id: (data.content.item[i].component_category_id != undefined && data.content.item[i].component_category_id != null && data.content.item[i].component_category_id != '')?{value: data.content.item[i].component_category_id, text: self.titleCase(data.content.item[i].component_category_name + " (" + data.content.item[i].component_category_code +")")}:null,
                                wi_reason_id: (data.content.item[i].wi_reason_id != undefined && data.content.item[i].wi_reason_id != null && data.content.item[i].wi_reason_id != '')?{value: data.content.item[i].wi_reason_id, text: self.titleCase(data.content.item[i].wi_reason_name + " (" + data.content.item[i].wi_reason_code +")")}:null,
                                defect_id: (data.content.item[i].standard_defect_id != undefined && data.content.item[i].standard_defect_id != null && data.content.item[i].standard_defect_id != '')?{value: data.content.item[i].standard_defect_id, text: self.titleCase(data.content.item[i].standard_defect_name + " (" + data.content.item[i].standard_defect_code +")")}:null,
                                woicomplaint: data.content.item[i].complaint,
                                woicause: data.content.item[i].cause,
                                woicorrection: data.content.item[i].correction


                                // subtotal: 0,
                                // hasLabor: false,
                                // hasComp: false

                            });

                            self.serviceTaskArr.push({value: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '')?data.content.item[i].task_id:null, text: data.content.item[i].task_name, index: self.taskArr.length-1});

                        }
                    }

                    if(data.content.comp != undefined){
                        for ( var i=0; i<data.content.comp.length; i++ ) {

                            self.compArr.push({
                                cid: (data.content.comp[i].cid != undefined && data.content.comp[i].cid != null && data.content.comp[i].cid != '')?data.content.comp[i].cid:0,
                                compid: {value: data.content.comp[i].compid, text:data.content.comp[i].compname},
                                service_task_id: {value: data.content.comp[i].service_task_id, text:data.content.comp[i].service_task_name, index: data.content.comp[i].service_task_index},
                                compcost: data.content.comp[i].compcost,
                                compquantity: data.content.comp[i].compquantity,
                                compsubtotal: data.content.comp[i].compsubtotal,
                                compdescription: data.content.comp[i].compdescription
                            });

                        }
                    }

                    if(data.content.comment != undefined){
                        for ( var i=0; i<data.content.comment.length; i++ ) {

                            self.commentArr.push({
                                wocId: (data.content.comment[i].wocId != undefined && data.content.comment[i].wocId != null && data.content.comment[i].wocId != '')?data.content.comment[i].wocId:0,
                                service_task_id: {value: data.content.comment[i].service_task_id, text:data.content.comment[i].service_task_name, index: data.content.comment[i].service_task_index},
                                wocType: {value: data.content.comment[i].wocTypeId, text:self.titleCase(data.content.comment[i].wocTypeName)+' ('+data.content.comment[i].wocType+')'},
                                woc: data.content.comment[i].woc,
                                wocBy: data.content.comment[i].wocBy,
                                wocAt: data.content.comment[i].wocAt
                            });

                        }
                    }

                    if(data.content.labor != undefined){
                        for ( var i=0; i<data.content.labor.length; i++ ) {
                            // alert(data.content.labor[i].laborsubtotal);
                            self.laborArr.push({
                                lid: (data.content.labor[i].lid != undefined && data.content.labor[i].lid != null && data.content.labor[i].lid != '')?data.content.labor[i].lid:0,
                                // laborid: null,
                                service_task_id: {value: data.content.labor[i].service_task_id, text:data.content.labor[i].service_task_name, index: data.content.labor[i].service_task_index},
                                laborhours: data.content.labor[i].laborhours,
                                laborhourrate: data.content.labor[i].laborhourrate,
                                laborsubtotal: data.content.labor[i].laborsubtotal,
                                labordescription: data.content.labor[i].labordescription
                            });

                        }
                    }

                    //crm activity for work order
                    if(data.content.activity != undefined){
                        for ( var i=0; i<data.content.activity.length; i++ ) {

                            // self.activityArr.push({
                            //     woeiId:(data.content.activity[i].ewoiId != undefined && data.content.activity[i].ewoiId != null && data.content.activity[i].ewoiId != '')?data.content.activity[i].ewoiId:0,
                            //     crmId:(data.content.activity[i].crmId != undefined && data.content.activity[i].crmId != null && data.content.activity[i].crmId != '')?data.content.activity[i].crmId:0,
                            //     service_task_index: data.content.activity[i].service_task_index,
                            //     activity_type: data.content.activity[i].activity_type,
                            //     notes: (data.content.activity[i].notes != null && data.content.activity[i].notes != undefined && data.content.activity[i].notes != '')?data.content.activity[i].notes:'',
                            //     activityBy: data.content.activity[i].activityBy,
                            //     activityAt: data.content.activity[i].activityAt,
                            // });
                             self.activityArr.push({
                                    // woiId: (data.content.activity[i].woiId != undefined && data.content.activity[i].woiId != null && data.content.activity[i].woiId != '') ? data.content.activity[i].woiId : 0,
                                    // crmId: (data.content.activity[i].crmId != undefined && data.content.activity[i].crmId != null && data.content.activity[i].crmId != '') ? data.content.activity[i].crmId : 0,
                                    service_task_index: data.content.activity[i].service_task_index,
                                    activity_type: data.content.activity[i].name,
                                    notes: (data.content.activity[i].details != null && data.content.activity[i].details != undefined && data.content.activity[i].details != '') ? data.content.activity[i].details : '',
                                    activityBy: data.content.activity[i].performed_by,
                                    activityAt: data.content.activity[i].performed_at,
                                });
                        }
                    }

                    //bind jScrollPane
                    setTimeout(function () {
                        $(function()
                        {
                            var settings = {
                                showArrows: true
                            };
                            var pane = $('.comment-list-btm')
                            pane.jScrollPane();
                            var api = pane.data('jsp');
                            // api.getContentPane().append(

                            // );
                            api.reinitialise();

                            //activity jScrollPane
                            var settingsActivity = {
                                showArrows: true
                            };
                            var paneActivity = $('.activity-list-btm')
                            paneActivity.jScrollPane();
                            var apiActivity = paneActivity.data('jsp');
                            apiActivity.reinitialise();

                        });
                    },200);
                    if( self.taskArr.length > 0){
                        //in order to show entire line item on add line item button click...
                        self.activeLineItemIdx = 0;
                    }

                } else if( data.code == 201 ) {

                    console.log('No line item is assigned with wo..')
                    self.addSetOfTask();

                }
            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR, true,'get-vendor-estimate-items');
            }
        });
    },
    //task validations
    taskValidations(flag,index){
        var self = this;
        var error = false;

        if(flag == "labor"){
            var showComponent = 'addLabor'+index;
            //assign laborIndex in case of Add Labor
            console.log("taskValidations laborIndex before :: " + self.laborIndex);
            console.log("taskValidations laborArr.length :: " + self.laborArr.length);
            if(self.laborArr.length > 0){
               self.laborIndex = self.laborArr.length;
            }
            self.serviceTaskLaborDesc_error_msg = '';
            self.serviceTaskLaborHour_error_msg = '';

            console.log("taskValidations laborIndex after :: " + self.laborIndex);

        }else if(flag == "serviceTaskComp"){
            var showComponent = 'addComponent'+index;
            self.serviceTaskComp_error_msg = "";
        }else{
            var showComponent = 'addComment'+index;
        }

        if(self.taskArr != undefined){

            $("#component_category_id" + index + " .dropdown-toggle").removeClass('border-red');
            $("#taskid" + index + " .dropdown-toggle").removeClass('border-red');

            $("#woicomplaint" + index).removeClass('border-red');
            $("#woicause" + index).removeClass('border-red');
            $("#woicorrection" + index).removeClass('border-red');

            if (self.taskArr[index].component_category_id == null || !self.taskArr[index].component_category_id.value) {
                $("#component_category_id" + index + " .dropdown-toggle").addClass('border-red');
                self.showActiveTaskLabor = showComponent;
            }
            if (self.taskArr[index].taskid == null || !self.taskArr[index].taskid.value) {
                $("#taskid" + index + " .dropdown-toggle").addClass('border-red');
                self.showActiveTaskLabor = showComponent;
            }

            // if (self.taskArr[index].woicomplaint == "" || self.taskArr[index].woicomplaint == '') {
            //     $("#woicomplaint" + index).addClass('border-red');
            //     self.showActiveTaskLabor = showComponent;
            // }
            // if (self.taskArr[index].woicause == "" || self.taskArr[index].woicause == '') {
            //     $("#woicause" + index).addClass('border-red');
            //     self.showActiveTaskLabor = showComponent;
            // }
            // if (self.taskArr[index].woicorrection == "" || self.taskArr[index].woicorrection == '') {
            //     $("#woicorrection" + index).addClass('border-red');
            //     self.showActiveTaskLabor = showComponent;
            // }

        }
    },
    //remove work order line item task, labor or component
    removeWoVendorEstimateLineItem(flag,params,index){

        var self = this;
        //current Duration of LaborTime Log
        var currentDuration = "00:00";

        if (confirm('Are you sure that you want to remove this line? ')) {

            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/vendor-estimate/remove-wo-vendor-estimate-line-item",
                type: "POST",
                data: {'flag':flag,'params':params},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    if (data.status == "success" ) {
                        //labor time log remove
                        if(flag == "log"){
                            //get time difference
                            self.serviceTaskLaborHour = self.getDifference(self.serviceTaskLaborHour,currentDuration,"diff");
                        }
                        self.loadWoVendorEstimate();
                    }

                },
                error: function (jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR, true,'remove-vendor-estimate-line-item');
                },
            });
        }

    },

    //validate time
    validateTime(value){

        var timeValue = value;
        if(timeValue == "" || timeValue.indexOf(":")<0)
        {
            return false;
        }
        else
        {
            var sHours = timeValue.split(':')[0];
            var sMinutes = timeValue.split(':')[1];

            if(sHours == "" || isNaN(sHours) || parseInt(sHours)>23 || sHours.length < 2 || sHours.length > 2)
            {
                return false;
            }

            if(sMinutes == "" || isNaN(sMinutes) || parseInt(sMinutes)>59 || sMinutes.length < 2 || sMinutes.length > 2)
            {
                return false;
            }

            value = sHours + ":" + sMinutes;

        }
        return true;
    },
    toSeconds(time_str) {
        // Extract hours, minutes and seconds
        var parts = time_str.split(':');
        // compute  and return total seconds
        return parseInt(parts[0]) * 3600 + // an hour has 3600 seconds
        parseInt(parts[1]) * 60;// a minute has 60 seconds
    },

    getDifference(time1,time2,flag){
        var self = this;
        var t1 = time1;
        var t2 = time2;

        if(flag == "add"){
            var difference = Math.abs(self.toSeconds(t1) + self.toSeconds(t2));
        }else if(flag == "diff"){
            var difference = Math.abs(self.toSeconds(t1) - self.toSeconds(t2));
            console.log("getDifference difference:: " + difference);
        }

        // format time differnece
        var result = [
            Math.floor(difference / 3600), // an hour has 3600 seconds
            Math.floor((difference % 3600) / 60) // a minute has 60 seconds
        ];
        console.log("getDifference result:: " + result);
        // 0 padding and concatation
        result = result.map(function(v) {
            return v < 10 ? '0' + v : v;
        }).join(':');
        console.log("getDifference map result:: " + result);
        return result;

    },
    getTotalTime(logTimeArr){
        var self = this;
        var totalTime = 0;

        for(var i=0;i<logTimeArr.length;i++){
            console.log(logTimeArr[i]);
            totalTime += self.toSeconds(logTimeArr[i]);
            console.log(totalTime);
        }

         var result = [
            Math.floor(totalTime / 3600), // an hour has 3600 seconds
            Math.floor((totalTime % 3600) / 60) // a minute has 60 seconds
        ];
        console.log("getDifference result:: " + result);
        // 0 padding and concatation
        result = result.map(function(v) {
            return v < 10 ? '0' + v : v;
        }).join(':');
        console.log("getTotalTime map result:: " + result);
        return result;
    },
    removeFileFromServer(file, woveId,flag){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/vendor-estimate/remove-doc",
            type: "POST",
            data: {
                filePath : file,
                id: woveId,
                flag:flag
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {

                self.loading = false;
            },
            error: function (jqXHR, exception) {

                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, true,'remove-vendor-estimate-document');
            }
        });

    },
    // getWorkOrderDataForEstimate: function(woId,itemId){
    //     var self = this;


    // }
    getWorkOrderDataForEstimate(wo_id,itemId) {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            // var woItems = itemId.split(',');

            // let wo_id = (segments[3] != undefined) ? segments[3] : self.woId;
            //unbind jScrollPane
            setTimeout(function () {
                $(function () {
                    var pane = $('.comment-list-btm');
                    pane.jScrollPane();
                    var api = pane.data('jsp');
                    if (api != undefined) {
                        api.destroy();
                    }

                    //activity jScrollPane
                    var paneActivity = $('.activity-list-btm');
                    paneActivity.jScrollPane();
                    var apiActivity = paneActivity.data('jsp');
                    if (apiActivity != undefined) {
                        apiActivity.destroy();
                    }
                });
            }, 200);

            $.ajax({
                url: process.env.ROOT_API + "/get-workorder-items",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    work_order_id: wo_id,
                    wo_item_ids:itemId
                },
                success: function (data) {

                    if (data.code == 200) {

                    self.taskArr = [];
                    self.compArr = [];
                    self.laborArr = [];
                    self.commentArr = [];
                    self.laborHourArr = [];
                    self.activityArr = [];

                    if (data.content.item != undefined) {
                        self.serviceTaskArr = []

                        if ( data.content.item[0] && data.content.item[0].vendorid){

                            self.vendor_id = {text:data.content.item[0].vendorname+' | '+data.content.item[0].vendorcode,value:data.content.item[0].vendorid};
                        }

                        for (var i = 0; i < data.content.item.length; i++) {

                            self.taskArr.push({

                                workOrderItemId: (data.content.item[i].wo_item_id != undefined && data.content.item[i].wo_item_id != null && data.content.item[i].wo_item_id != '')?data.content.item[i].wo_item_id:0,
                                woiId: 0,
                                taskid: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '') ? {
                                    value: data.content.item[i].task_id,
                                    text: self.titleCase(data.content.item[i].task_name + " (" + data.content.item[i].task_code + ")")
                                } : null,
                                laboramount: data.content.item[i].labor_amount,
                                partamount: data.content.item[i].component_amount,
                                component_category_id: (data.content.item[i].component_category_id != undefined && data.content.item[i].component_category_id != null && data.content.item[i].component_category_id != '') ? {
                                    value: data.content.item[i].component_category_id,
                                    text: self.titleCase(data.content.item[i].component_category_name + " (" + data.content.item[i].component_category_code + ")")
                                } : null,
                                wi_reason_id: (data.content.item[i].wi_reason_id != undefined && data.content.item[i].wi_reason_id != null && data.content.item[i].wi_reason_id != '') ? {
                                    value: data.content.item[i].wi_reason_id,
                                    text: self.titleCase(data.content.item[i].wi_reason_name + " (" + data.content.item[i].wi_reason_code + ")")
                                } : null,
                                billable_code: (data.content.item[i].billable_code != undefined && data.content.item[i].billable_code != null && data.content.item[i].billable_code != '') ? {
                                    value: data.content.item[i].billable_code,
                                    text: self.titleCase(data.content.item[i].billable_code_name + " (" + data.content.item[i].billable_code + ")")
                                } : null,
                                defect_id: (data.content.item[i].standard_defect_id != undefined && data.content.item[i].standard_defect_id != null && data.content.item[i].standard_defect_id != '') ? {
                                    value: data.content.item[i].standard_defect_id,
                                    text: self.titleCase(data.content.item[i].standard_defect_name + " (" + data.content.item[i].standard_defect_code + ")")
                                } : null,
                                woistatus: {
                                    value: data.content.item[i].woistatus,
                                    text: self.titleCase(data.content.item[i].woistatus)
                                },
                                woicomplaint: data.content.item[i].complaint,
                                woicause: data.content.item[i].cause,
                                woicorrection: data.content.item[i].correction,
                                woinotes: data.content.item[i].notes,

                                issublet: data.content.item[i].issublet,
                                purchaseorderid: (data.content.item[i].purchaseorderid != undefined && data.content.item[i].purchaseorderid != null && data.content.item[i].purchaseorderid != '') ? {
                                    value: data.content.item[i].purchaseorderid,
                                    text: self.titleCase(data.content.item[i].purchaseorderno) + " | " + data.content.item[i].purchaseordertotal
                                } : null,
                                vendorid: (data.content.item[i].vendorid != undefined && data.content.item[i].vendorid != null && data.content.item[i].vendorid != '') ? {
                                    value: data.content.item[i].vendorid,
                                    text: self.titleCase(data.content.item[i].vendorcode + " | " + data.content.item[i].vendorname)
                                } : null,
                                estimatedwoiId: (data.content.item[i].estimate_wo_item_id != undefined && data.content.item[i].estimate_wo_item_id != null && data.content.item[i].estimate_wo_item_id != '') ? data.content.item[i].estimate_wo_item_id : 0,
                                estimatedlaboramount: data.content.item[i].estimate_wo_item_labor_amount

                                // subtotal: 0,
                                // hasLabor: false,
                                // hasComp: false

                            });

                            self.serviceTaskArr.push({
                                value: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '') ? data.content.item[i].task_id : null,
                                text: data.content.item[i].task_name,
                                index: self.taskArr.length - 1
                            });

                        }
                    }

                    if (data.content.comp != undefined) {
                        for (var i = 0; i < data.content.comp.length; i++) {

                            self.compArr.push({
                                cid: 0,
                                wo_comp_id: (data.content.comp[i].cid != undefined && data.content.comp[i].cid != null && data.content.comp[i].cid != '') ? data.content.comp[i].cid : 0,
                                compid: {
                                    value: data.content.comp[i].compid,
                                    text: data.content.comp[i].compname
                                },
                                service_task_id: {
                                    value: data.content.comp[i].service_task_id,
                                    text: data.content.comp[i].service_task_name,
                                    index: data.content.comp[i].service_task_index
                                },
                                compcost: 0,
                                compquantity: data.content.comp[i].compquantity,
                                compsubtotal: 0,
                                compdescription: data.content.comp[i].compdescription,
                                estimatedcid: (data.content.comp[i].estimate_cid != undefined && data.content.comp[i].estimate_cid != null && data.content.comp[i].estimate_cid != '') ? data.content.comp[i].estimate_cid : 0
                            });

                        }
                    }

                    if (data.content.comment != undefined) {
                        for (var i = 0; i < data.content.comment.length; i++) {

                            self.commentArr.push({
                                wocId: 0,
                                wo_comment_id: (data.content.comment[i].wocId != undefined && data.content.comment[i].wocId != null && data.content.comment[i].wocId != '') ? data.content.comment[i].wocId : 0,
                                service_task_id: {
                                    value: data.content.comment[i].service_task_id,
                                    text: data.content.comment[i].service_task_name,
                                    index: data.content.comment[i].service_task_index
                                },
                                wocType: {
                                    value: data.content.comment[i].wocTypeId,
                                    text: self.titleCase(data.content.comment[i].wocTypeName) + ' (' + data.content.comment[i].wocType + ')'
                                },
                                woc: data.content.comment[i].woc,
                                wocBy: data.content.comment[i].wocBy,
                                wocAt: data.content.comment[i].wocAt,
                                estimatedwocId: (data.content.comment[i].estimate_wocId != undefined && data.content.comment[i].estimate_wocId != null && data.content.comment[i].estimate_wocId != '') ? data.content.comment[i].estimate_wocId : 0
                            });

                        }
                    }

                    if (data.content.labor != undefined) {

                        for (var i = 0; i < data.content.labor.length; i++) {

                            self.laborArr.push({
                                lid: 0,
                                wo_labor_id: (data.content.labor[i].lid != undefined && data.content.labor[i].lid != null && data.content.labor[i].lid != '') ? data.content.labor[i].lid : 0,
                                laborid: (data.content.labor[i].laborid != undefined && data.content.labor[i].laborid != null && data.content.labor[i].laborid != '') ? {
                                    value: data.content.labor[i].laborid,
                                    text: data.content.labor[i].laborname
                                } : null,
                                service_task_id: {
                                    value: data.content.labor[i].service_task_id,
                                    text: data.content.labor[i].service_task_name,
                                    index: data.content.labor[i].service_task_index
                                },
                                laborhours: data.content.labor[i].laborhours,
                                laborhourrate: data.content.labor[i].laborhourrate,
                                laborsubtotal: data.content.labor[i].laborsubtotal,
                                labordescription: data.content.labor[i].labordescription
                            });

                            if (data.content.timelog != undefined) {
                                for (var k = 0; k < data.content.timelog.length; k++) {
                                    if (data.content.timelog[k].lid == data.content.labor[i].lid) {
                                        self.laborHourArr.push({
                                            timelog_id: 0,
                                            timelogid: (data.content.timelog[k].timelogid != undefined && data.content.timelog[k].timelogid != null && data.content.timelog[k].timelogid != '') ? data.content.timelog[k].timelogid : 0,
                                            labor_id: data.content.timelog[k].lid,
                                            start_time: (data.content.timelog[k].start_time != null && data.content.timelog[k].start_time != undefined && data.content.timelog[k].start_time != '') ? data.content.timelog[k].start_time : '-',
                                            end_time: (data.content.timelog[k].end_time != null && data.content.timelog[k].end_time != undefined && data.content.timelog[k].end_time != '') ? data.content.timelog[k].end_time : '-',
                                            duration: (data.content.timelog[k].duration != null && data.content.timelog[k].duration != undefined && data.content.timelog[k].duration != '') ? data.content.timelog[k].duration : '-',
                                            labor_index: i
                                        });

                                        // console.log('to check hrere =>'+data.content.timelog[k].start_time);
                                        // console.log('to check hrere =>'+data.content.timelog[k].end_time);
                                        // if(data.content.timelog[k].start_time == null && data.content.timelog[k].end_time == null){
                                        //     self.timeLabel = 'Start Log Time'
                                        // }else if(data.content.timelog[k].end_time == null){
                                        //     self.timeLabel = 'End Log Time'
                                        // }
                                    }

                                }
                            }

                        }
                    }

                    //crm activity for work order
                    if (data.content.activity != undefined) {
                        for (var i = 0; i < data.content.activity.length; i++) {

                            self.activityArr.push({
                                woiId: 0,
                                crmId: (data.content.activity[i].crmId != undefined && data.content.activity[i].crmId != null && data.content.activity[i].crmId != '') ? data.content.activity[i].crmId : 0,
                                service_task_index: data.content.activity[i].service_task_index,
                                activity_type: data.content.activity[i].activity_type,
                                notes: (data.content.activity[i].notes != null && data.content.activity[i].notes != undefined && data.content.activity[i].notes != '') ? data.content.activity[i].notes : '',
                                activityBy: data.content.activity[i].activityBy,
                                activityAt: data.content.activity[i].activityAt,
                            });
                        }
                    }

                    //bind jScrollPane
                    setTimeout(function () {
                        $(function () {
                            var settings = {
                                showArrows: true
                            };
                            var pane = $('.comment-list-btm')
                            pane.jScrollPane();
                            var api = pane.data('jsp');
                            // api.getContentPane().append(

                            // );
                            api.reinitialise();

                            //activity jScrollPane
                            var settingsActivity = {
                                showArrows: true
                            };
                            var paneActivity = $('.activity-list-btm')
                            paneActivity.jScrollPane();
                            var apiActivity = paneActivity.data('jsp');
                            apiActivity.reinitialise();

                        });
                    }, 200);

                    } else if (data.code == 201) {

                        console.log('No line item is assigned with wo..')
                        self.addSetOfTask();

                    }
                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true,'vendor-estimate-get-wo-items');
                }
            });
        },
        onSearchVMRS(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'vmrs', '');
            }
        },

  }
};
</script>

<style scoped>
#partTable #compquantity {
    border: 1px solid rgba(60,60,60,.26);
}
#laborTable #laborhours{
    border: 1px solid rgba(60,60,60,.26);
}
</style>



// WEBPACK FOOTER //
// src/components/workorderestimate/VendorEstimateCreate.vue